import { Tooltip } from 'antd'
import BreadCrumb from 'components/BreadCrumb'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import IntentToOfferTemplate from 'components/EmailTemplate/IntentToOfferTemplate'
import ShortlistedTemplate from 'components/EmailTemplate/ShortlistedTemplate'
import LeftArrow from 'components/icons/LeftArrow'
import SuccessIcon from 'components/icons/SubmitCloseIcon'
import EvaluationForm from 'modules/ATS/Components/EvaluationForm.js'
import IndividualDriveTable from 'modules/ATS/Components/IndividualTable/index.js'
import {
  sendInAppNotification,
  sendNotificationBulkEmail,
  sendNotificationBulkEmailWhatsapp,
} from 'modules/Students/actions'
import { FooterFlex } from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import {
  SectionWrapper,
  TopHeader,
  TopHeading,
  TopRightFlex,
} from 'modules/Students/Style/style'
import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import ReactDOMServer from 'react-dom/server'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'
import ExportTransfer from '../../components/ExportTransfer'
import AtsExportIcon from '../../components/icons/AtsExportIcon'
import BulkDownloadIcon from '../../components/icons/BulkDownloadIcon'
import PopUpPageIcon from '../../components/icons/PopUpPageIcon'
import CloseRoleDrawer from '../../components/UIComponents/CloseRolePopup'
import SucessfullPopup from '../../components/UIComponents/CloseRolePopup/SucessfullModelPopup'
import { EmptyDivElement } from '../../components/UIComponents/CommonStyledComponent'
import Debounce from '../../utils/Debounce'
import { singlePdf, zipFile } from '../../utils/downloadFile'
import { toCamelCase } from '../../utils/helpers'
import DriveRoleMetrics from './Components/Metrics'
import ResolveConflict from './Components/ResolveConflict'
import ResultUploader from './Components/ResultUploader'
import AddConfirm from './Components/Upload'
import {
  CandidatesSpan,
  ConflictName,
  LeftSection,
  Minus,
  SectionName,
  ShortList,
  StyledTab,
  TextEllipse,
} from './style'
import EmailPopup from 'components/SendEmailPopup/EmailPopup'
import SuccessDialog from 'components/SuccessDialog' // Import SuccessDialog

const getTagMessage = (status, offerStatus) => {
  let tagMessage = 'Yet to Update' // Default tag message

  switch (status) {
    case 'SCHEDULED':
    case 'HELD_TO_COMPARE':
    case 'STATUS_CONFLICT':
    case 'MOVE_TO_NEXT_ROUND':
    case 'TO_BE_UPDATED':
    case 'REJECT':
    case 'HOLD_TO_COMPARE':
      tagMessage = 'Scheduled'
      break
    case 'TO_BE_SCHEDULED':
      tagMessage = 'To be scheduled'
      break
    case 'INVITED':
      tagMessage = 'Invited'
      break
    case 'SHORTLISTED':
      tagMessage = 'Shortlisted'
      break
    case 'COMPLETED':
      tagMessage = 'Completed'
      break
    case 'QUALIFIED':
      tagMessage = 'Qualified'
      break
    case 'REJECTED':
      tagMessage = 'Rejected'
      break
    case 'ABSENT':
      tagMessage = 'Absent'
      break
    case 'RESCHEDULE_REQUESTED':
      tagMessage = 'Req.Reschedule'
      break
    case 'RESCHEDULED':
    case 'RESCHEDULE':
      tagMessage = 'Rescheduled'
      break
    case 'SELECTED':
      switch (offerStatus) {
        case 'RELEASED':
          tagMessage = 'Offer Issued'
          break
        case 'ACCEPTED':
          tagMessage = 'Offer Accepted'
          break
        case 'REJECTED':
          tagMessage = 'Offer Declined'
          break
        default:
          tagMessage = 'Update status'
      }
      break
    case 'RELEASED':
      tagMessage = 'Offer letter released'
      break
    case 'ACTIVE':
      tagMessage = 'Update status'
      break
    case 'OFFER_RECEIVED':
      tagMessage = 'Offer received'
      break
    case 'ACCEPTED':
      tagMessage = 'Offer Accepted'
      break
    default:
      tagMessage = 'Yet to Update'
  }

  return tagMessage
}

const staticStatus = [
  {
    label: 'Update Status',
    value: 'UPDATE STATUS',
    nameValue: 'Status - Update Status',
    role: 'Status',
    key: 'UPDATE_STATUS',
  },
  {
    label: 'Rejected',
    value: 'Rejected',
    nameValue: 'Status - Rejected',
    role: 'Status',
    key: 'REJECTED',
  },
  {
    label: 'Offer Issued',
    value: 'OFFER ISSUED',
    nameValue: 'Status - Offer Issued',
    role: 'Status',
    key: 'RELEASED',
  },
  {
    label: 'Offer Accepted',
    value: 'OFFER ACCEPTED',
    nameValue: 'Status - Offer Accepted',
    role: 'Status',
    key: 'ACCEPTED',
  },
  {
    label: 'Offer Declined',
    value: 'OFFER REJECTED',
    nameValue: 'Status - Offer Declined',
    role: 'Status',
    key: 'REJECTED',
  },
  {
    label: 'To Be Scheduled',
    value: 'TO BE SCHEDULED',
    nameValue: 'Status - To Be Scheduled',
    role: 'Status',
    key: 'TO_BE_SCHEDULED',
  },
]

const PageHeader = ({
  addNewRound,
  roundData,
  updateNewRound,
  updateRoundData,
  getMetrics,
  getCandidate,
  instituteCampusId,
  updateCandidateRoleStatus,
  bulkUploadForAts,
  resolveConflict,
  getCandidateDegree,
  getCandidateDepart,
  getExportFiledData,
  atsExportCandidate,
  getPreview,
  getPlacementHistoryList,
  getJobRolePreview,
  getStudentPlacedList,
  statusFilterList,
  jobRolePreviewData,
  corporateFilterList,
  studentFilterList,
  resumeBulkDownload,
  resumeBulkDownloadJobRoles,
  getCandidateSpecialization,
  StudentEmailList,
}) => {
  const dispatch = useDispatch()
  const institute = useSelector(state => state.auth.instituteDetails)
  const userDataFull = useSelector(state => state.auth.userDataFull)
  const userRole = useSelector(state => state.auth.userRoleList)
  
  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? 'Admin'
  }

  const getUserRoleName = () => {
    return getRoleName(
      userDataFull?.pluginlive_id
        ? userDataFull?.admin?.instRoleId
        : userDataFull?.admin_role_id ?? userDataFull?.role_id
    )
  }
  console.log(userDataFull,'userDataFull')
  const object = useRef()
  const params = useParams()
  const { userData, instituteDetails } = useSelector(state => state.auth)
  const navigate = useNavigate()
  const { TabPane } = StyledTab
  const [openDrawer, setOpenDrawer] = useState(false)
  const [progress, setProgress] = useState(10)
  const [failed, setFailed] = useState(false)
  const [bulkUploadResult, setBulkUploadResult] = useState({})
  const [actionDrawer, setActionDrawer] = useState(false)
  const [sortedItems, setSortedItems] = useState([])
  const [save, setSave] = useState(false)
  let [searchParams, setSearchParams] = useSearchParams()
  const stage = searchParams.get('stage')
  const publishedBy = searchParams.get('publishedBy')
  const stageIndex = searchParams.get('stageindex')
  const currentSearchParams = new URLSearchParams(window.location.search)
  const checkType = currentSearchParams.get('jobType')?.replace(/ /g, '%20')
  const [count, setCount] = useState(0)
  const [selectedRound, setSelectedRound] = useState(stage ?? 'all_candidates')
  const [currentTab, setCurrentTab] = useState('ACTIVE')

  const [selectedCandidate, setSelectedCandidate] = useState([])
  const [selectedCandidateId, setSelectedCandidateId] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [status, setStatus] = useState('ACTIVE')

  const [candidates, setCandidates] = useState({})
  const [panelValue, setPanelValue] = useState('all')
  const [filterStatus, setFilterStatus] = useState('ACTIVE')
  const [panelData, setPanelData] = useState('')
  const [updateStatus, setUpdateStatus] = useState([])
  const [rolesMetrics, setRolesMetrics] = useState([])
  const [load, setLoad] = useState(false)
  const [successFull, setSuccessFull] = useState(false)
  const [finalUpload, setFinalUpload] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [conflictData, setConflictData] = useState([])
  const [conflictStatus, setConflictStatus] = useState('')
  const [conflictFilter, setConflictFilter] = useState({
    search: '',
    page: 0,
  })
  const [debouncedSearch, setDebouncedSearch] = useState(
    () => conflictFilter.search
  )
  const [scheduleTrue, setScheduleTrue] = useState(false)
  const [isEditingForm, setIsEditingForm] = useState(false)
  const [checkStatus, setCheckStatus] = useState([])
  const [checkGender, setCheckGender] = useState([])
  const [checkSkills, setCheckSkills] = useState([])
  const [checkYear, setCheckYear] = useState([])
  const [checkScore, setCheckScore] = useState([])
  const [scoreEntries, setScoreEntries] = useState([])
  const [checkArrears, setCheckArrears] = useState([])
  const [checkLocation, setCheckLocation] = useState([])
  const [multiSelect, setMultiSelect] = useState([])
  const [filterCheck, setFilterCheck] = useState(false)
  const [searchBy, setSearchBy] = useState('')
  const [debouncedSearchBy, setDebouncedSearchBy] = useState('')
  const [filterSearchText, setFilterSearchText] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [saveEnable, setSaveEnable] = useState(false)
  const [file, setFile] = useState('')
  const [sortBy, setSortBy] = useState('')
  const [bulkUploadError, setBulkUploadError] = useState('')
  const [wholeSelect, setWholeSelect] = useState(false)
  const [skillsFilter, setSkillsFilter] = useState([])
  const [locationFilter, setLocationFilter] = useState([])
  const [yearFilter, setYearFilter] = useState([])
  const [genderFilter, setGenderFilter] = useState([])
  const [bulkDownload, setBulkDownload] = useState(false)
  const [popup, setPopup] = useState(false)
  const [studentListId, setStudentListId] = useState([])
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)
  const [ArrearsFilter, setArrearsFilter] = useState([])
  const [isEmailPopupVisible, setIsEmailPopupVisible] = useState(false);
  const [exportFile, setExportFile] = useState(null); // Add state for the file
    const [selectedExportMethod, setSelectedExportMethod] = useState('')
  const [selectedExportType, setSelectedExportType] = useState([])
  const [googleSheetUrl, setGoogleSheetUrl] = useState('')
  const [showEmailSuccessDialog, setShowEmailSuccessDialog] = useState(false); // Add this state
  const [studentCount, setStudentCount] = useState(0);
  const removeParams = () => {
    const url = new URL(window.location)
    url.searchParams.delete('schedule')
    window.history.pushState({}, '', url)
  }
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setOpenDrawer(false)
            removeParams()
            setIsEditingForm(false)
          }}
        />
        <Button.Primary
          htmlType="submit"
          form="bulkUpload"
          text="Save"
          icon={!save}
          disabled={saveEnable || isEditingForm}
          onClick={() => {
            setSave(true)
            // setOpenDrawer(false)
            setIsEditingForm(false)
            removeParams()
          }}
        />
      </FooterFlex>
    )
  }

  const uploadFooter = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setFile()
            setActionDrawer(false)
          }}
        />
        <Button.Primary
          htmlType="submit"
          form="bulkUpload"
          text="Update"
          disable={Object?.keys(bulkUploadResult)?.length === 0}
          onClick={() => handleUpdate()}
        />
      </FooterFlex>
    )
  }

  const ConflictContent = () => {
    return (
      <ResolveConflict
        conflictData={conflictData}
        conflictFilter={conflictFilter}
        handlePageChange={handlePageChange}
        handleSearch={handleSearch}
        // handleShortListBtn={handleShortListBtn}
        isLoading={isLoading}
        columns={ConflictColumn}
      />
    )
  }

  const ConflictColumn = [
    {
      width: 140,
      title: 'Uploaded Data',
      dataIndex: 'Uploaded Data',
      key: 'Uploaded Data',
      className: 'uploaded-data',
      render: (text, record) => {
        const { email, lastName, firstName, phoneNumber } =
          record.uploadedCandidateData
        const disable = record.candidateDetails.every(
          item =>
            item.primaryEmail?.toLowerCase()?.trim() ===
            email?.toLowerCase()?.trim()
        )
        const nameDisable = record.candidateDetails.every(
          item =>
            item?.student?.firstName?.toLowerCase()?.trim() ===
            firstName?.toLowerCase()?.trim()
        )
        const lastDisable = record.candidateDetails.every(
          item =>
            item?.student?.lastName?.toLowerCase()?.trim() ===
            lastName?.toLowerCase()?.trim()
        )
        const phoneDisable = record?.candidateDetails?.every(
          item => item?.phoneNumber?.trim() === phoneNumber?.trim()
        )

        return (
          <Tooltip
            title={
              <div>
                {firstName}
                {lastName}
                <br />
                {phoneNumber}
                <br />
                {email}
              </div>
            }
          >
            <TextEllipse disable={nameDisable}>
              {firstName}{' '}
              <span
                style={{ color: lastDisable ? '#000' : 'rgb(227, 94, 80)' }}
              >
                {lastName}
              </span>
            </TextEllipse>

            <ConflictName disable={phoneDisable}>{phoneNumber}</ConflictName>
            <ConflictName disable={disable}>{email}</ConflictName>
          </Tooltip>
        )
      },
      onCell: (record, index) => {
        const rowSpan =
          record.candidateDetails.length == 0
            ? 1
            : record.candidateDetailIndex === 0
            ? record.candidateDetails.length
            : 0
        return { rowSpan }
      },
    },
    {
      width: 140,
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const { student } = record?.candidateDetail || {}
        const disable =
          record?.uploadedCandidateData?.firstName?.toLowerCase()?.trim() ===
          student?.firstName?.toLowerCase()?.trim()

        const lastDisable =
          record?.uploadedCandidateData?.lastName?.toLowerCase()?.trim() ===
          student?.lastName?.toLowerCase()?.trim()

        //display

        let firstName = student?.firstName
          ? toCamelCase(student?.firstName)
          : ''
        let lastName = student?.lastName ? toCamelCase(student?.lastName) : ''
        return (
          <>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {firstName} {lastName}
                  </div>
                }
              >
                <ConflictName disable={disable} caps={true}>
                  {firstName}{' '}
                  <span
                    style={{ color: lastDisable ? '#000' : 'rgb(227, 94, 80)' }}
                  >
                    {lastName}
                  </span>
                </ConflictName>
              </Tooltip>
            )}
          </>
        )
      },
    },
    {
      width: 140,
      title: 'Contact details',
      dataIndex: 'Contact details',
      key: 'Contact details',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const { primaryEmail, secondaryEmail, phoneNumber } =
          record?.candidateDetail || {}
        const EmailDisable =
          primaryEmail?.toLowerCase()?.trim() ===
          record?.uploadedCandidateData?.email?.toLowerCase()?.trim()
        const secondaryEmailDisable =
          secondaryEmail?.toLowerCase()?.trim() ===
          record?.uploadedCandidateData?.email?.toLowerCase()?.trim()
        const phoneDisable =
          phoneNumber?.trim() ===
          record?.uploadedCandidateData?.phoneNumber?.trim()

        //display
        let pEmail = primaryEmail ? primaryEmail?.toLowerCase() : primaryEmail
        let sEmail = secondaryEmail
          ? secondaryEmail?.toLowerCase()
          : secondaryEmail
        return (
          <>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {pEmail}
                    <br />
                    {sEmail}
                    <br />
                    {phoneNumber}
                  </div>
                }
              >
                <ConflictName disable={EmailDisable}>{pEmail}</ConflictName>
                <ConflictName disable={secondaryEmailDisable}>
                  {sEmail}
                </ConflictName>
                <ConflictName disable={phoneDisable}>
                  {phoneNumber}
                </ConflictName>
              </Tooltip>
            )}
          </>
        )
      },
    },
    {
      width: 140,
      title: 'Degree & Department',
      dataIndex: 'Degree & Department',
      key: 'Degree & Department',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const { degree, department } =
          record?.candidateDetail?.student?.currentCourse ??
          record?.candidateDetail?.student ??
          {}
        let Degree = degree ? toCamelCase(degree) : degree
        let Department = department ? toCamelCase(department) : department
        return (
          <div style={{ textAlign: 'left' }}>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {Degree}
                    <br />
                    {Department}
                  </div>
                }
              >
                <ConflictName disable={true} caps={true}>
                  {Degree}
                </ConflictName>
                <ConflictName disable={true} caps={true}>
                  {Department}
                </ConflictName>
              </Tooltip>
            )}
          </div>
        )
      },
    },
    {
      width: 140,
      title: 'Status action',
      dataIndex: 'Status action',
      key: 'Status action',
      className: 'conflict-staus-action',
      render: (text, record) => {
        const disable = record.candidateDetail === null
        return (
          <ShortList
            disable={disable}
            onClick={() =>
              handleShortListBtn(
                record?.candidateDetail?.studentId,
                record?.roundId,
                record?.uploadedCandidateData?.offerStatus,
                true,
                record?.id
              )
            }
          >
            Shortlist
          </ShortList>
        )
      },
    },
  ]

  let corporateTabs = [
    {
      tabName: 'Active',
      count: candidates?.totalCount,
      key: 'ACTIVE',
    },
    {
      tabName: 'Scheduled',
      count: candidates?.scheduledCount,
      key: 'SCHEDULED',
    },
    {
      tabName: 'Re-Schedule',
      count: candidates?.rescheduleCount,
      key: 'RESCHEDULED',
    },
    {
      tabName: 'Shortlisted',
      count: candidates?.qualifiedCount,
      key: 'QUALIFIED',
    },
    {
      tabName: 'Rejected',
      count: candidates?.rejectedCount,
      key: 'REJECTED',
    },
    {
      tabName: 'Absent',
      count: candidates?.absentCount,
      key: 'ABSENT',
    },
  ]
  const tabList =
    publishedBy == 'CORPORATE'
      ? corporateTabs
      : [
          {
            tabName: 'Active',
            count: candidates?.activeCount,
            key: 'ACTIVE',
          },
          {
            tabName: 'Shortlisted',
            count: candidates?.shortlistedCount,
            key: 'SHORTLISTED',
          },
          {
            tabName: 'Rejected',
            count: candidates?.rejectedCount,
            key: 'REJECTED',
          },
          {
            tabName: 'Absent',
            count: candidates?.absentCount,
            key: 'ABSENT',
          },
        ]

  const OfferTabList =
    publishedBy == 'CORPORATE'
      ? [
          {
            tabName: 'Intent to Offer',
            count: candidates?.intentToOfferCount,
            key: 'ACTIVE',
          },
          {
            tabName: 'Offer Issued',
            count: candidates?.offerCount,
            key: 'RELEASED',
          },
          {
            tabName: 'Offer Accepted',
            count: candidates?.offerAccpetCount,
            key: 'ACCEPTED',
          },
          {
            tabName: 'Offer Declined',
            count: candidates?.offerRejectCount,
            key: 'REJECTED',
          },
        ]
      : [
          {
            tabName: 'Intent to Offer',
            count: candidates?.activeCount,
            key: 'ACTIVE',
          },
          {
            tabName: 'Offer Issued',
            count: candidates?.offerIssuedCount,
            key: 'RELEASED',
          },
          {
            tabName: 'Offer Accepted',
            count: candidates?.offerAccepedCount,
            key: 'ACCEPTED',
          },
          {
            tabName: 'Offer Declined',
            count: candidates?.offerDeclinedCount,
            key: 'REJECTED',
          },
        ]

  const [roundValues, setRoundValues] = useState({
    roundName: '',
    roundNameError: '',
    interviewType: '',
    interviewTypeError: '',
    assessmentType: '',
    assessmentTypeError: '',
    roundDescription: '',
    roundDescriptionError: '',
    faceToFaceType: '',
    faceToFaceTypeError: '',
    startDateError: '',
    endDateError: '',
    startDate: null,
    endDate: null,
    id: '',
    prePlacement: false,
  })

  const handleUpdate = async () => {
    if (finalUpload == 2) {
      let payLoad = {
        studentId: bulkUploadResult?.data?.rejectionCandidateIds,
        forAllCandidate: false,
        status: stage == 'offer' ? 'SELECTED' : 'REJECTED',
        stage: stage,
        roundId: rolesMetrics?.rounds[stageIndex]?.id,
      }
      if (stage == 'offer') {
        payLoad.offerStatus = 'REJECTED'
      }
      await updateCandidateRoleStatus(
        payLoad,
        instituteCampusId,
        params?.roleId
      )
      setFile()

      setSuccessFull(true)
    } else {
      setFile()

      setSuccessFull(true)
    }
  }

  useEffect(() => {
    if (rolesMetrics?.rounds?.length && stageIndex) {
      getConflict()
    }
  }, [rolesMetrics, conflictFilter.page, debouncedSearch])

  useEffect(() => {
    getJobRolePreview(params?.roleId)
  }, [])

  useEffect(() => {
    const fetchCorporateFilterList = async () => {
      try {
        const response = await corporateFilterList(params?.roleId)

        if (response?.message === 'Success') {
          // Process skills data
          if (response?.data?.skills && response?.data?.skills.length > 0) {
            const skillsOptions = response.data.skills.map(skill => ({
              id: skill.id,
              key: skill.id,
              label: skill.name,
              value: skill.name,
              title: skill.name,
              nameValue: `Skill - ${skill.name}`,
              role: 'Skills',
            }))

            // Set skills data to state (assuming you have a state setter for skills)
            setSkillsFilter(skillsOptions)
          }

          // Process locations data
          if (
            response?.data?.locations &&
            response?.data?.locations.length > 0
          ) {
            const locationOptions = response.data.locations
              .filter(location => {
                // Skip locations where isAnyWhere property exists but is false
                return !(
                  location.hasOwnProperty('isAnyWhere') && !location.isAnyWhere
                )
              })
              .map(location => {
                // Handle the special case for "anywhere" location
                if (
                  location.hasOwnProperty('isAnyWhere') &&
                  location?.isAnyWhere
                ) {
                  return {
                    key: 'anywhere',
                    label: 'Anywhere',
                    value: 'isAnyWhere',
                    title: 'Anywhere',
                    nameValue: 'Location - Anywhere',
                    role: 'Location',
                    isAnyWhere: location?.isAnyWhere,
                  }
                }

                return {
                  id: location?.id ? location?.id : location?.state_id,
                  key: location?.id ? location?.id : location?.state_id,
                  label: location?.name ? location?.name : location?.state_name,
                  value: location?.id ? location?.id : location?.state_id,
                  title: location?.name ? location?.name : location?.state_name,
                  nameValue: `Location - ${
                    location?.name ? location?.name : location?.state_name
                  }`,
                  role: 'Location',
                }
              })

            // Set locations data to state (assuming you have a state setter for locations)
            setLocationFilter(locationOptions)
          }
        }
      } catch (error) {
        console.error('Error fetching corporate filter list:', error)
      }
    }

    fetchCorporateFilterList() // Call the async function
  }, [])

  useEffect(() => {
    const fetchStudentFilterList = async () => {
      try {
        const response = await studentFilterList(params?.roleId)
        if (
          response?.data?.filters?.endedOnYears &&
          response?.data?.filters.endedOnYears.length > 0
        ) {
          const yearsData = response.data.filters.endedOnYears.map(year => ({
            value: year.toString(),
            name: year.toString(),
            title: year.toString(),
            nameValue: `Year of passing - ${year.toString()}`,
            role: 'Year',
          }))
          setYearFilter(yearsData)
        }

        // Set gender filter with proper mapping
        if (
          response?.data?.filters?.genders &&
          response?.data?.filters?.genders.length > 0
        ) {
          const genderMap = {
            MALE: 'Male',
            FEMALE: 'Female',
            TRANSGENDER: 'Transgender',
            INTERSEX: 'Intersex',
            NON_BINARY: 'Non Binary',
            PREFER_NOT_TO_SAY: 'Prefer not to say',
            OTHER: 'Other',
          }

          // const gendersData = response?.data?.filters?.genders?.map(gender => ({
          //   value: gender,
          //   name: genderMap[gender] || gender,
          //   label: genderMap[gender] || gender,
          //   nameValue: `Gender - ${genderMap[gender] || gender}`,
          //   role: 'Gender',
          // }))
          const gendersData = [
            {
              value: 'MALE',
              name: 'Male',
              label: 'Male',
              nameValue: 'Gender - Male',
              role: 'Gender',
            },
            {
              value: 'FEMALE',
              name: 'Female',
              label: 'Female',
              nameValue: 'Gender - Female',
              role: 'Gender',
            },
            {
              value: 'OTHERS',
              name: 'Others',
              label: 'Others',
              nameValue: 'Gender - Others',
              role: 'Gender',
            },
          ]
          setGenderFilter(gendersData)
        }
      } catch (error) {
        console.error('Error fetching corporate filter list:', error)
      }
    }

    fetchStudentFilterList() // Call the async function
  }, [])
  useEffect(() => {
    const fetchStatusFilterList = async () => {
      try {
        const response = await statusFilterList(params?.roleId, stage)

        if (response?.message === 'Success') {
          let status = response?.data?.map(item => item?.status)
          let a = staticStatus?.filter(item => {
            return status?.includes(item.key)
          })
          const option = response?.data?.map(item => {
            return {
              ...item,
              key: item.keys?.join(','),
              label: getTagMessage(item?.status),
              // value: 'OFFER REJECTED',
              nameValue: `Status - ${getTagMessage(item?.status)}`,
              role: 'Status',
              value: getTagMessage(item?.status)?.replace(/_/g, ' '),
            }
          })
          setCorporateFilterStatus(option)
        }
      } catch (error) {
        console.error('Error fetching status filter list:', error)
      }
    }

    fetchStatusFilterList() // Call the async function
  }, [params?.roleId, stage])

  useEffect(() => {
    if (bulkDownload) {
      fetchCandidateList(params?.roleId)
    }
  }, [bulkDownload])
  const getConflict = async () => {
    try {
      if (publishedBy == 'INSTITUTE') {
        let roundId = rolesMetrics?.rounds?.[parseInt(stageIndex) ?? 0]?.id
        setIsLoading(true)
        const getConflictData = await resolveConflict(
          instituteCampusId,
          params?.roleId,
          conflictFilter.page,
          conflictFilter.search,
          roundId
        )
        if (conflictFilter.search === '') {
          if (getConflictData?.count === 0) {
            setConflictDrawer(false)
          }
        }
        setIsLoading(false)
        setConflictData(getConflictData)
      }
    } catch (error) {
      ErrorMessage(error)
      setIsLoading(false)
    }
  }

  const handleUploadClick = getstatus => {
    setConflictStatus(getstatus)
  }
  const handleShortListBtn = async (
    item,
    roundId,
    offerStatus,
    forShowConflicts = false,
    conflictId = ''
  ) => {
    try {
      setIsLoading(true)
      let payLoad = {
        studentId: item,
        roundId: rolesMetrics?.rounds?.[stageIndex]?.id,
        forAllCandidate: false,
        ...(Array.isArray(rolesMetrics?.rounds) && rolesMetrics.rounds.length > 0 &&
        rolesMetrics.rounds[rolesMetrics.rounds.length - 1].name === stage
          ? { offerStatus: offerStatus, status: 'SELECTED' }
          : { status: 'SHORTLISTED' }),
        stage: stage,
        forShowConflicts,
        conflictId,
      }
      const result = await updateCandidateRoleStatus(
        payLoad,
        instituteCampusId,
        params.roleId
      )

      if (
        payLoad.status === 'SHORTLISTED' &&
        Array.isArray(rolesMetrics?.rounds) && rolesMetrics.rounds.length > 1 &&
        rolesMetrics.rounds[rolesMetrics.rounds.length - 2].name != stage
      ) {
        try {
          const currentRound =
            rolesMetrics?.rounds[parseInt(stageIndex) + 1]?.name || 'next round'
          const prevRound =
            rolesMetrics?.rounds[parseInt(stageIndex)]?.name || 'previous round'

          // Get company name from jobRolePreviewData
          const companyName =
            jobRolePreviewData?.company?.companyName ??
            jobRolePreviewData?.corporate?.name ??
            'the company'

          // Check if we have successful candidates from the API response
          const successCandidates = result?.data?.data?.successCandidate || []

          // Process each successful candidate
          if (successCandidates.length > 0) {
            // Arrays to hold notification payloads
            const emailPayloads = []
            const whatsappPayloads = []
            const inAppNotifications = []

            // Process each candidate
            successCandidates.forEach(candidate => {
              // Get student data from API response
              const studentId = candidate.id
              const studentName = candidate.name
              const studentEmail = candidate.primaryEmail
              const studentPhone = candidate.phoneNumber

              // Prepare data for email template
              const emailData = {
                studentName,
                companyName: companyName,
                roundName: currentRound,
                prevRoundName: prevRound,
                roleName:
                  jobRolePreviewData?.tittle ||
                  rolesMetrics?.tittle ||
                  'the role',
                signatureName:
                  userData?.first_name + ' ' + userData?.last_name,
                signatureRole: getUserRoleName(),
                signatureInstitute: institute?.campusName || 'Institute',
                signatureContact:
                  userData?.phone_number || institute?.contactNumber,
              }

              // Render the email template for this candidate
              const emailTemplate = ReactDOMServer.renderToString(
                <ShortlistedTemplate data={emailData} />
              )

              // Add to email payloads
              emailPayloads.push({
                to: studentEmail, // Use actual student email
                subject: `Moved to Next Round`,
                htmlBody: emailTemplate,
              })

              // Add to in-app notifications
              inAppNotifications.push({
                ids: [studentId],
                userIds: [],
                roles: ['Student'],
                issuer: 'institute',
                createFor: 'student',
                inApp: true,
                body: `Congratulations! You've Been Selected\n${studentName} has been selected for ${
                  jobRolePreviewData?.tittle ||
                  rolesMetrics?.tittle ||
                  'the role'
                } at ${companyName}.`,
                tag: 'Role',
                actions: [
                  {
                    name: 'View',
                    deep_link: `roles/viewrole/${
                      jobRolePreviewData?.company?.id ||
                      rolesMetrics?.company?.id ||
                      'companyId'
                    }/${params?.roleId}`,
                    route: `roles/viewrole/${
                      jobRolePreviewData?.company?.id ||
                      rolesMetrics?.company?.id ||
                      'companyId'
                    }/${params?.roleId}`,
                    parameters: {},
                  },
                ],
              })

              // Add to WhatsApp payloads
              whatsappPayloads.push({
                to: studentPhone.replace(/\D/g, ''), // Use actual student phone
                templateName: 'tpo_application_movedtonextround',
                type: 'template',
                components: [
                  {
                    type: 'BODY',
                    parameters: [
                      { type: 'TEXT', text: studentName }, // {{1}} - Student name
                      { type: 'TEXT', text: currentRound }, // {{2}} - Round name
                      {
                        type: 'TEXT',
                        text:
                          jobRolePreviewData?.tittle ||
                          rolesMetrics?.tittle ||
                          'the role',
                      }, // {{3}} - Role
                      { type: 'TEXT', text: companyName }, // {{4}} - Company name
                    ],
                  },
                ],
              })
            })

            // Send email notifications
            if (emailPayloads.length > 0) {
              await dispatch(sendNotificationBulkEmail(emailPayloads))
            }

            // Send in-app notifications
            if (inAppNotifications.length > 0) {
              const inAppObj = {
                notification: {
                  students: inAppNotifications,
                },
              }
              await dispatch(sendInAppNotification(inAppObj))
            }

            // Send WhatsApp notifications
            if (whatsappPayloads.length > 0) {
              await dispatch(
                sendNotificationBulkEmailWhatsapp(whatsappPayloads)
              )
            }
          }
        } catch (error) {
          console.error('Error sending notifications:', error)
        }
      }

      // Check if status is SHORTLISTED and it is the last round
      if (
        payLoad.status === 'SHORTLISTED' &&
        Array.isArray(rolesMetrics?.rounds) && rolesMetrics.rounds.length > 1 &&
        rolesMetrics.rounds[rolesMetrics.rounds.length - 2].name === stage
      ) {
        try {
          const roundName =
            rolesMetrics?.rounds[parseInt(stageIndex)]?.name || 'assessment'

          // Get company name from jobRolePreviewData
          const companyName =
            jobRolePreviewData?.company?.companyName ??
            jobRolePreviewData?.corporate?.name ??
            'the company'

          // Check if we have successful candidates from the API response
          const successCandidates = result?.data?.data?.successCandidate || []

          // Process each successful candidate
          if (successCandidates.length > 0) {
            // Arrays to hold notification payloads
            const emailPayloads = []
            const whatsappPayloads = []
            const inAppNotifications = []

            // Process each candidate
            successCandidates.forEach(candidate => {
              // Get student data from API response
              const studentId = candidate.id
              const studentName = candidate.name
              const studentEmail = candidate.primaryEmail
              const studentPhone = candidate.phoneNumber

              // Prepare data for email template
              const emailData = {
                studentName,
                companyName: companyName,
                roundName: roundName,
                roleName:
                  jobRolePreviewData?.tittle ||
                  rolesMetrics?.tittle ||
                  'the role',
                signatureName:
                  userData?.first_name + ' ' + userData?.last_name,
                signatureRole: getUserRoleName(),
                signatureInstitute: institute?.campusName || 'Institute',
                signatureContact:
                  userData?.phone_number || institute?.contactNumber,
              }

              // Render the email template for this candidate
              const emailTemplate = ReactDOMServer.renderToString(
                <IntentToOfferTemplate data={emailData} />
              )

              // Add to email payloads
              emailPayloads.push({
                to: studentEmail, // Use actual student email
                subject: `Congratulations! You've been Selected for ${
                  jobRolePreviewData?.tittle ||
                  rolesMetrics?.tittle ||
                  'the role'
                }`,
                htmlBody: emailTemplate,
              })

              // Add to in-app notifications
              inAppNotifications.push({
                ids: [studentId],
                userIds: [],
                roles: ['Student'],
                issuer: 'institute',
                createFor: 'student',
                inApp: true,
                body: `Congratulations! You've Been Selected\n${studentName} has been selected for ${
                  jobRolePreviewData?.tittle ||
                  rolesMetrics?.tittle ||
                  'the role'
                } at ${companyName}.`,
                tag: 'Role',
                actions: [
                  {
                    name: 'View',
                    deep_link: `roles/viewrole/${
                      jobRolePreviewData?.company?.id ||
                      rolesMetrics?.company?.id ||
                      'companyId'
                    }/${params?.roleId}`,
                    route: `roles/viewrole/${
                      jobRolePreviewData?.company?.id ||
                      rolesMetrics?.company?.id ||
                      'companyId'
                    }/${params?.roleId}`,
                    parameters: {},
                  },
                ],
              })

              // Add to WhatsApp payloads
              whatsappPayloads.push({
                to: studentPhone.replace(/\D/g, ''), // Use actual student phone
                templateName: 'tpo_application_intenttooffer',
                type: 'template',
                components: [
                  {
                    type: 'BODY',
                    parameters: [
                      { type: 'TEXT', text: studentName }, // {{1}} - Student name
                      {
                        type: 'TEXT',
                        text:
                          jobRolePreviewData?.tittle ||
                          rolesMetrics?.tittle ||
                          'the role',
                      }, // {{2}} - Role name
                      { type: 'TEXT', text: companyName }, // {{3}} - Company name
                    ],
                  },
                ],
              })
            })

            // Send email notifications
            if (emailPayloads.length > 0) {
              await dispatch(sendNotificationBulkEmail(emailPayloads))
            }

            // Send in-app notifications
            if (inAppNotifications.length > 0) {
              const inAppObj = {
                notification: {
                  students: inAppNotifications,
                },
              }
              await dispatch(sendInAppNotification(inAppObj))
            }

            // Send WhatsApp notifications
            if (whatsappPayloads.length > 0) {
              await dispatch(
                sendNotificationBulkEmailWhatsapp(whatsappPayloads)
              )
            }
          }
        } catch (error) {
          console.error('Error sending Intent to Offer notifications:', error)
        }
      }

      if (payLoad.status === 'SELECTED' && payLoad.offerStatus === 'RELEASED') {
        try {
          // Get company name from jobRolePreviewData
          const companyName =
            jobRolePreviewData?.company?.companyName ??
            jobRolePreviewData?.corporate?.name ??
            'the company'

          // Check if we have successful candidates from the API response
          const successCandidates = result?.data?.data?.successCandidate || []

          // Process each successful candidate
          if (successCandidates.length > 0) {
            // Collect all student IDs for a single in-app notification
            const allStudentIds = successCandidates.map(
              candidate => candidate.id
            )

            // Create a single in-app notification for all students
            const inAppObj = {
              notification: {
                students: [
                  {
                    ids: allStudentIds, // Include all student IDs in a single array
                    userIds: [],
                    roles: ['Student'],
                    issuer: 'institute',
                    createFor: 'student',
                    inApp: true,
                    body: `Your status has been updated to offer issued for the role of ${
                      jobRolePreviewData?.tittle ||
                      rolesMetrics?.tittle ||
                      'the role'
                    } at ${companyName}.`,
                    tag: 'Role',
                    actions: [
                      {
                        name: 'View',
                        deep_link: `roles/viewrole/${
                          jobRolePreviewData?.company?.id ||
                          rolesMetrics?.company?.id ||
                          'companyId'
                        }/${roleId}`,
                        route: `roles/viewrole/${
                          jobRolePreviewData?.company?.id ||
                          rolesMetrics?.company?.id ||
                          'companyId'
                        }/${roleId}`,
                        parameters: {},
                      },
                    ],
                  },
                ],
              },
            }

            // Send in-app notification
            await dispatch(sendInAppNotification(inAppObj))
          }
        } catch (error) {
          console.error('Error sending Offer Issued notification:', error)
        }
      }

      // Check for Offer Accepted status
      if (payLoad.status === 'SELECTED' && payLoad.offerStatus === 'ACCEPTED') {
        try {
          // Get company name from jobRolePreviewData
          const companyName =
            jobRolePreviewData?.company?.companyName ??
            jobRolePreviewData?.corporate?.name ??
            'the company'

          // Check if we have successful candidates from the API response
          const successCandidates = result?.data?.data?.successCandidate || []

          // Process each successful candidate
          if (successCandidates.length > 0) {
            // Collect all student IDs for a single in-app notification
            const allStudentIds = successCandidates.map(
              candidate => candidate.id
            )

            // Create a single in-app notification for all students
            const inAppObj = {
              notification: {
                students: [
                  {
                    ids: allStudentIds, // Include all student IDs in a single array
                    userIds: [],
                    roles: ['Student'],
                    issuer: 'institute',
                    createFor: 'student',
                    inApp: true,
                    body: `Your status has been updated to offer accepted for the role of ${
                      jobRolePreviewData?.tittle ||
                      rolesMetrics?.tittle ||
                      'the role'
                    } at ${companyName}.`,
                    tag: 'Role',
                    actions: [
                      {
                        name: 'View',
                        deep_link: `roles/viewrole/${
                          jobRolePreviewData?.company?.id ||
                          rolesMetrics?.company?.id ||
                          'companyId'
                        }/${roleId}`,
                        route: `roles/viewrole/${
                          jobRolePreviewData?.company?.id ||
                          rolesMetrics?.company?.id ||
                          'companyId'
                        }/${roleId}`,
                        parameters: {},
                      },
                    ],
                  },
                ],
              },
            }

            // Send in-app notification
            await dispatch(sendInAppNotification(inAppObj))
          }
        } catch (error) {
          console.error('Error sending Offer Accepted notification:', error)
        }
      }

      // Check for Offer Declined status
      if (payLoad.status === 'SELECTED' && payLoad.offerStatus === 'REJECTED') {
        try {
          // Get company name from jobRolePreviewData
          const companyName =
            jobRolePreviewData?.company?.companyName ??
            jobRolePreviewData?.corporate?.name ??
            'the company'

          // Check if we have successful candidates from the API response
          const successCandidates = result?.data?.data?.successCandidate || []

          // Process each successful candidate
          if (successCandidates.length > 0) {
            // Collect all student IDs for a single in-app notification
            const allStudentIds = successCandidates.map(
              candidate => candidate.id
            )

            // Create a single in-app notification for all students
            const inAppObj = {
              notification: {
                students: [
                  {
                    ids: allStudentIds, // Include all student IDs in a single array
                    userIds: [],
                    roles: ['Student'],
                    issuer: 'institute',
                    createFor: 'student',
                    inApp: true,
                    body: `Your status has been updated to offer declined for the role of ${
                      jobRolePreviewData?.tittle ||
                      rolesMetrics?.tittle ||
                      'the role'
                    } at ${companyName}.`,
                    tag: 'Role',
                    actions: [
                      {
                        name: 'View',
                        deep_link: `roles/viewrole/${
                          jobRolePreviewData?.company?.id ||
                          rolesMetrics?.company?.id ||
                          'companyId'
                        }/${roleId}`,
                        route: `roles/viewrole/${
                          jobRolePreviewData?.company?.id ||
                          rolesMetrics?.company?.id ||
                          'companyId'
                        }/${roleId}`,
                        parameters: {},
                      },
                    ],
                  },
                ],
              },
            }

            // Send in-app notification
            await dispatch(sendInAppNotification(inAppObj))
          }
        } catch (error) {
          console.error('Error sending Offer Declined notification:', error)
        }
      }

      let roundId = rolesMetrics?.rounds?.[parseInt(stageIndex) ?? 0]?.id

      const getConflictData = await resolveConflict(
        instituteCampusId,
        params?.roleId,
        conflictFilter.page,
        conflictFilter.search,
        roundId
      )
      setIsLoading(false)
      setConflictData(getConflictData)
      setConflictFilter({
        search: '',
        page: 0,
      })
      candidateCall(params?.roleId)
      fetchCandidateList(params?.roleId)
    } catch (error) {
      setIsLoading(false)
      ErrorMessage(error)
    }
  }

  const handlePageChange = pageNum => {
    setConflictFilter({ ...conflictFilter, page: pageNum - 1 })
  }

  const handleSearch = e => {
    setConflictFilter({ ...conflictFilter, search: e.target.value })
  }

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(conflictFilter.search)
      setConflictFilter({ ...conflictFilter, page: 0 })
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [conflictFilter.search])

  useEffect(() => {
    if (openDrawer) {
      setRoundValues({
        roundName: '',
        roundNameError: '',
        interviewType: '',
        interviewTypeError: '',
        assessmentType: '',
        assessmentTypeError: '',
        roundDescription: '',
        roundDescriptionError: '',
        faceToFaceType: '',
        faceToFaceTypeError: '',
        startDateError: '',
        endDateError: '',
        startDate: null,
        endDate: null,
        id: '',
        prePlacement: false,
      })
    }
  }, [openDrawer])

  const candidateCall = async roleId => {
    try {
      const data = await getMetrics(instituteCampusId, roleId, publishedBy)
      if (publishedBy == 'CORPORATE') {
        data.rounds = data.round?.map(item => ({
          ...item,
          name: item.roundName,
        }))
        delete data.round
      }

      setRolesMetrics(data)
    } catch (error) {
      ErrorMessage(error)
    }
  }

  const fetchCandidateList = async (
    roleId,
    page = currentPage,
    sort = sortBy
  ) => {
    if (bulkDownload === false) {
      setLoad(true)
    }
    if (roleId) {
      const result = await getCandidate(
        instituteCampusId,
        roleId,
        stage,
        stageIndex,
        searchBy,
        checkStatus,
        state.selectedCourse,
        state.selectedDepartCourse,
        publishedBy,
        sort,
        status,
        page,
        bulkDownload,
        checkSkills,
        checkYear,
        scoreEntries,
        checkArrears,
        checkGender,
        checkLocation,
        state.selectedSplCourse
      )

      if (result?.message == 'Success') {
        if (bulkDownload === true) {
          setPopup(true)
          setStudentListId(result?.data?.studentIds)
        } else {
          // Check if data has candidateList structure (corporate format)
          // This handles both corporate roles and corporate-created roles viewed from institute
          if (result?.data?.candidateList !== undefined) {
            result.data.result = result?.data?.candidateList || []
            delete result?.data?.candidateList
          }
          setCandidates(result?.data)
        }
      }

      setLoad(false)
    }
  }

  const ScrollRef = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }

  const onPageChange = pagNum => {
    ScrollRef()
    setCurrentPage(pagNum - 1)
    let page = pagNum - 1
    fetchCandidateList(params?.roleId, page)
  }

  const content = () => {
    return (
      <EvaluationForm
        updateNewRound={updateNewRound}
        addNewRound={addNewRound}
        roundData={roundData}
        updateRoundData={updateRoundData}
        sortedItems={sortedItems}
        setSortedItems={setSortedItems}
        save={save}
        setSave={setSave}
        openDrawer={openDrawer}
        setRoundValues={setRoundValues}
        roundValues={roundValues}
        atsParam={params?.roleId}
        candidateCall={candidateCall}
        setOpenDrawer={setOpenDrawer}
        scheduleTrue={scheduleTrue}
        setScheduleTrue={setScheduleTrue}
        isEditingForm={isEditingForm}
        setIsEditingForm={setIsEditingForm}
        setSaveEnable={setSaveEnable}
        rolesMetrics={rolesMetrics}
        StudentEmailList={StudentEmailList}
        roleData={jobRolePreviewData}
      />
    )
  }

  const uploaderContent = () => {
    return (
      <>
        {successFull ? (
          <AddConfirm
            finalUpload={finalUpload}
            onClose={() => {
              setFile()
              setActionDrawer(false)
            }}
          />
        ) : (
          <ResultUploader
            bulkUpload={bulkUpload}
            roleId={params?.roleId}
            openDrawer={actionDrawer}
            progress={progress}
            setFailed={setFailed}
            failed={failed}
            setFinalUpload={setFinalUpload}
            finalUpload={finalUpload}
            bulkUploadResult={bulkUploadResult}
            stage={stage}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            handleResolveConflict={handleResolveConflict}
            handleUploadClick={handleUploadClick}
            conflictStatus={conflictStatus}
            candidates={candidates}
            file={file}
            setFile={setFile}
            bulkUploadError={bulkUploadError}
          />
        )}
      </>
    )
  }
  const onTabChange = key => {
    if (checkStatus.length !== 0) {
      setCheckStatus([])
      setFilterCheck(true)
    }
    setCheckGender([])
    setCheckSkills([])
    setCheckYear([])
    setScoreEntries([])
    setCheckArrears([])
    setCheckLocation([])
    setStatus(key)
    setFilterStatus(key)
    setCurrentTab(key)
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setCurrentPage(0)
    setCount(count + 1)

    setPanelValue('all')
    setPanelData('')
    setSearchBy('')
    setFilterSearchText(false)
    setWholeSelect(false)
    setSelectAll(false)
  }

  useEffect(() => {
    if (params?.roleId) {
      candidateCall(params?.roleId)
      fetchCandidateList(params?.roleId)
      handleDegree({})
    }
  }, [
    params?.roleId,
    stage,
    roundData,
    status,
    updateStatus,
    successFull,
    multiSelect,
  ])

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    if (
      queryParams.get('schedule') &&
      queryParams.get('schedule') !== 'false'
    ) {
      setOpenDrawer(true)
    } else {
      setOpenDrawer(false)
    }
  }, [window.location.search])

  useEffect(() => {
    if (filterSearchText) {
      fetchCandidateList(params?.roleId)
    }
  }, [debouncedSearchBy])

  useEffect(() => {
    setSelectedCandidateId([])
    setSelectedCandidate([])
  }, [updateStatus])

  const bulkUpload = async fileUrl => {
    try {
      if (fileUrl) {
        setIsLoading(true)
        setBulkUploadResult({})
        let payLoad = {
          stage: stage,
          fileUrl,
          roundId: rolesMetrics?.rounds?.[stageIndex]?.id,
          ...(conflictStatus !== '' ? { offerStatus: conflictStatus } : {}),
        }
        if (!failed) {
          const interval = setInterval(() => {
            setProgress(prevProgress => {
              const nextProgress = prevProgress + 10
              if (nextProgress >= 100) {
                clearInterval(interval)
                return 100
              }
              return nextProgress
            })
          }, 1000)
        }
        const result = await bulkUploadForAts(
          payLoad,
          instituteCampusId,
          params?.roleId
        )

        if (
          Array.isArray(rolesMetrics?.rounds) && rolesMetrics.rounds.length > 1 &&
          rolesMetrics.rounds[rolesMetrics.rounds.length - 2].name != stage &&
          stage !== 'offer'
        ) {
          try {
            const currentRound =
              rolesMetrics?.rounds[parseInt(stageIndex) + 1]?.name ||
              'next round'
            const prevRound =
              rolesMetrics?.rounds[parseInt(stageIndex)]?.name ||
              'previous round'

            // Get company name from jobRolePreviewData
            const companyName =
              jobRolePreviewData?.company?.companyName ??
              jobRolePreviewData?.corporate?.name ??
              'the company'

            // Check if we have successful candidates from the API response
            const successCandidates =
              result?.data?.data?.matchedCandidates || []

            // Process each successful candidate
            if (successCandidates.length > 0) {
              // Arrays to hold notification payloads
              const emailPayloads = []
              const whatsappPayloads = []
              const inAppNotifications = []

              // Process each candidate
              successCandidates.forEach(candidate => {
                // Get student data from API response
                const studentId = candidate?.candidateDetails?.studentId
                const studentName =
                  candidate?.candidateDetails?.student?.firstName +
                  ' ' +
                  candidate?.candidateDetails?.student?.lastName
                const studentEmail = candidate?.candidateDetails?.primaryEmail
                const studentPhone =
                  candidate?.candidateDetails?.phoneNumber.replace(/\D/g, '')

                // Prepare data for email template
                const emailData = {
                  studentName,
                  companyName: companyName,
                  roundName: currentRound,
                  prevRoundName: prevRound,
                  roleName:
                    jobRolePreviewData?.tittle ||
                    rolesMetrics?.tittle ||
                    'the role',
                  signatureName:
                    userData?.first_name + ' ' + userData?.last_name,
                  signatureRole: getUserRoleName(),
                  signatureInstitute: institute?.campusName || 'Institute',
                  signatureContact:
                    userData?.phone_number || institute?.contactNumber,
                }

                // Render the email template for this candidate
                const emailTemplate = ReactDOMServer.renderToString(
                  <ShortlistedTemplate data={emailData} />
                )

                // Add to email payloads
                emailPayloads.push({
                  to: studentEmail, // Use actual student email
                  subject: `Moved to Next Round`,
                  htmlBody: emailTemplate,
                })

                // Add to in-app notifications
                inAppNotifications.push({
                  ids: [studentId],
                  userIds: [],
                  roles: ['Student'],
                  issuer: 'institute',
                  createFor: 'student',
                  inApp: true,
                  body: `Congratulations! You've Been Selected\n${studentName} has been selected for ${
                    jobRolePreviewData?.tittle ||
                    rolesMetrics?.tittle ||
                    'the role'
                  } at ${companyName}.`,
                  tag: 'Role',
                  actions: [
                    {
                      name: 'View',
                      deep_link: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${params?.roleId}`,
                      route: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${params?.roleId}`,
                      parameters: {},
                    },
                  ],
                })

                // Add to WhatsApp payloads
                whatsappPayloads.push({
                  to: studentPhone.replace(/\D/g, ''), // Use actual student phone
                  templateName: 'tpo_application_movedtonextround',
                  type: 'template',
                  components: [
                    {
                      type: 'BODY',
                      parameters: [
                        { type: 'TEXT', text: studentName }, // {{1}} - Student name
                        { type: 'TEXT', text: currentRound }, // {{2}} - Round name
                        {
                          type: 'TEXT',
                          text:
                            jobRolePreviewData?.tittle ||
                            rolesMetrics?.tittle ||
                            'the role',
                        }, // {{3}} - Role
                        { type: 'TEXT', text: companyName }, // {{4}} - Company name
                      ],
                    },
                  ],
                })
              })

              // Send email notifications
              if (emailPayloads.length > 0) {
                await dispatch(sendNotificationBulkEmail(emailPayloads))
              }

              // Send in-app notifications
              if (inAppNotifications.length > 0) {
                const inAppObj = {
                  notification: {
                    students: inAppNotifications,
                  },
                }
                await dispatch(sendInAppNotification(inAppObj))
              }

              // Send WhatsApp notifications
              if (whatsappPayloads.length > 0) {
                await dispatch(
                  sendNotificationBulkEmailWhatsapp(whatsappPayloads)
                )
              }
            }
          } catch (error) {
            console.error('Error sending notifications:', error)
          }
        }

        // Check if status is SHORTLISTED and it is the last round
        if (
          Array.isArray(rolesMetrics?.rounds) && rolesMetrics.rounds.length > 1 &&
          rolesMetrics.rounds[rolesMetrics.rounds.length - 2].name === stage
        ) {
          try {
            const roundName =
              rolesMetrics?.rounds[parseInt(stageIndex)]?.name || 'assessment'

            // Get company name from jobRolePreviewData
            const companyName =
              jobRolePreviewData?.company?.companyName ??
              jobRolePreviewData?.corporate?.name ??
              'the company'

            // Check if we have successful candidates from the API response
            const successCandidates =
              result?.data?.data?.matchedCandidates || []

            // Process each successful candidate
            if (successCandidates.length > 0) {
              // Arrays to hold notification payloads
              const emailPayloads = []
              const whatsappPayloads = []
              const inAppNotifications = []

              // Process each candidate
              successCandidates.forEach(candidate => {
                // Get student data from API response
                const studentId = candidate?.candidateDetails?.studentId
                const studentName =
                  candidate?.candidateDetails?.student?.firstName +
                  ' ' +
                  candidate?.candidateDetails?.student?.lastName
                const studentEmail = candidate?.candidateDetails?.primaryEmail
                const studentPhone =
                  candidate?.candidateDetails?.phoneNumber.replace(/\D/g, '')

                // Prepare data for email template
                const emailData = {
                  studentName,
                  companyName: companyName,
                  roundName: roundName,
                  roleName:
                    jobRolePreviewData?.tittle ||
                    rolesMetrics?.tittle ||
                    'the role',
                  signatureName:
                    userData?.first_name + ' ' + userData?.last_name,
                  signatureRole: getUserRoleName(),
                  signatureInstitute: institute?.campusName || 'Institute',
                  signatureContact:
                    userData?.phone_number || institute?.contactNumber,
                }

                // Render the email template for this candidate
                const emailTemplate = ReactDOMServer.renderToString(
                  <IntentToOfferTemplate data={emailData} />
                )

                // Add to email payloads
                emailPayloads.push({
                  to: studentEmail, // Use actual student email
                  subject: `Congratulations! You've been Selected for ${
                    jobRolePreviewData?.tittle ||
                    rolesMetrics?.tittle ||
                    'the role'
                  }`,
                  htmlBody: emailTemplate,
                })

                // Add to in-app notifications
                inAppNotifications.push({
                  ids: [studentId],
                  userIds: [],
                  roles: ['Student'],
                  issuer: 'institute',
                  createFor: 'student',
                  inApp: true,
                  body: `Congratulations! You've Been Selected\n${studentName} has been selected for ${
                    jobRolePreviewData?.tittle ||
                    rolesMetrics?.tittle ||
                    'the role'
                  } at ${companyName}.`,
                  tag: 'Role',
                  actions: [
                    {
                      name: 'View',
                      deep_link: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${params?.roleId}`,
                      route: `roles/viewrole/${
                        jobRolePreviewData?.company?.id ||
                        rolesMetrics?.company?.id ||
                        'companyId'
                      }/${params?.roleId}`,
                      parameters: {},
                    },
                  ],
                })

                // Add to WhatsApp payloads
                whatsappPayloads.push({
                  to: studentPhone.replace(/\D/g, ''), // Use actual student phone
                  templateName: 'tpo_application_intenttooffer',
                  type: 'template',
                  components: [
                    {
                      type: 'BODY',
                      parameters: [
                        { type: 'TEXT', text: studentName }, // {{1}} - Student name
                        {
                          type: 'TEXT',
                          text:
                            jobRolePreviewData?.tittle ||
                            rolesMetrics?.tittle ||
                            'the role',
                        }, // {{2}} - Role name
                        { type: 'TEXT', text: companyName }, // {{3}} - Company name
                      ],
                    },
                  ],
                })
              })

              // Send email notifications
              if (emailPayloads.length > 0) {
                await dispatch(sendNotificationBulkEmail(emailPayloads))
              }

              // Send in-app notifications
              if (inAppNotifications.length > 0) {
                const inAppObj = {
                  notification: {
                    students: inAppNotifications,
                  },
                }
                await dispatch(sendInAppNotification(inAppObj))
              }

              // Send WhatsApp notifications
              if (whatsappPayloads.length > 0) {
                await dispatch(
                  sendNotificationBulkEmailWhatsapp(whatsappPayloads)
                )
              }
            }
          } catch (error) {
            console.error('Error sending Intent to Offer notifications:', error)
          }
        }

        if (payLoad.offerStatus === 'RELEASED') {
          try {
            // Get company name from jobRolePreviewData
            const companyName =
              jobRolePreviewData?.company?.companyName ??
              jobRolePreviewData?.corporate?.name ??
              'the company'

            // Check if we have successful candidates from the API response
            const successCandidates =
              result?.data?.data?.matchedCandidates || []

            // Process each successful candidate
            if (successCandidates.length > 0) {
              // Collect all student IDs for a single in-app notification
              const allStudentIds = successCandidates.map(
                candidate => candidate?.candidateDetails?.studentId
              )

              // Create a single in-app notification for all students
              const inAppObj = {
                notification: {
                  students: [
                    {
                      ids: allStudentIds, // Include all student IDs in a single array
                      userIds: [],
                      roles: ['Student'],
                      issuer: 'institute',
                      createFor: 'student',
                      inApp: true,
                      body: `Your status has been updated to offer issued for the role of ${
                        jobRolePreviewData?.tittle ||
                        rolesMetrics?.tittle ||
                        'the role'
                      } at ${companyName}.`,
                      tag: 'Role',
                      actions: [
                        {
                          name: 'View',
                          deep_link: `roles/viewrole/${
                            jobRolePreviewData?.company?.id ||
                            rolesMetrics?.company?.id ||
                            'companyId'
                          }/${roleId}`,
                          route: `roles/viewrole/${
                            jobRolePreviewData?.company?.id ||
                            rolesMetrics?.company?.id ||
                            'companyId'
                          }/${roleId}`,
                          parameters: {},
                        },
                      ],
                    },
                  ],
                },
              }

              // Send in-app notification
              await dispatch(sendInAppNotification(inAppObj))
            }
          } catch (error) {
            console.error('Error sending Offer Issued notification:', error)
          }
        }

        // Check for Offer Accepted status
        if (payLoad.offerStatus === 'ACCEPTED') {
          try {
            // Get company name from jobRolePreviewData
            const companyName =
              jobRolePreviewData?.company?.companyName ??
              jobRolePreviewData?.corporate?.name ??
              'the company'

            // Check if we have successful candidates from the API response
            const successCandidates =
              result?.data?.data?.matchedCandidates || []

            // Process each successful candidate
            if (successCandidates.length > 0) {
              // Collect all student IDs for a single in-app notification
              const allStudentIds = successCandidates.map(
                candidate => candidate?.candidateDetails?.studentId
              )

              // Create a single in-app notification for all students
              const inAppObj = {
                notification: {
                  students: [
                    {
                      ids: allStudentIds, // Include all student IDs in a single array
                      userIds: [],
                      roles: ['Student'],
                      issuer: 'institute',
                      createFor: 'student',
                      inApp: true,
                      body: `Your status has been updated to offer accepted for the role of ${
                        jobRolePreviewData?.tittle ||
                        rolesMetrics?.tittle ||
                        'the role'
                      } at ${companyName}.`,
                      tag: 'Role',
                      actions: [
                        {
                          name: 'View',
                          deep_link: `roles/viewrole/${
                            jobRolePreviewData?.company?.id ||
                            rolesMetrics?.company?.id ||
                            'companyId'
                          }/${roleId}`,
                          route: `roles/viewrole/${
                            jobRolePreviewData?.company?.id ||
                            rolesMetrics?.company?.id ||
                            'companyId'
                          }/${roleId}`,
                          parameters: {},
                        },
                      ],
                    },
                  ],
                },
              }

              // Send in-app notification
              await dispatch(sendInAppNotification(inAppObj))
            }
          } catch (error) {
            console.error('Error sending Offer Accepted notification:', error)
          }
        }

        // Check for Offer Declined status
        if (payLoad.offerStatus === 'REJECTED') {
          try {
            // Get company name from jobRolePreviewData
            const companyName =
              jobRolePreviewData?.company?.companyName ??
              jobRolePreviewData?.corporate?.name ??
              'the company'

            // Check if we have successful candidates from the API response
            const successCandidates =
              result?.data?.data?.matchedCandidates || []

            // Process each successful candidate
            if (successCandidates.length > 0) {
              // Collect all student IDs for a single in-app notification
              const allStudentIds = successCandidates.map(
                candidate => candidate?.candidateDetails?.studentId
              )

              // Create a single in-app notification for all students
              const inAppObj = {
                notification: {
                  students: [
                    {
                      ids: allStudentIds, // Include all student IDs in a single array
                      userIds: [],
                      roles: ['Student'],
                      issuer: 'institute',
                      createFor: 'student',
                      inApp: true,
                      body: `Your status has been updated to offer declined for the role of ${
                        jobRolePreviewData?.tittle ||
                        rolesMetrics?.tittle ||
                        'the role'
                      } at ${companyName}.`,
                      tag: 'Role',
                      actions: [
                        {
                          name: 'View',
                          deep_link: `roles/viewrole/${
                            jobRolePreviewData?.company?.id ||
                            rolesMetrics?.company?.id ||
                            'companyId'
                          }/${roleId}`,
                          route: `roles/viewrole/${
                            jobRolePreviewData?.company?.id ||
                            rolesMetrics?.company?.id ||
                            'companyId'
                          }/${roleId}`,
                          parameters: {},
                        },
                      ],
                    },
                  ],
                },
              }

              // Send in-app notification
              await dispatch(sendInAppNotification(inAppObj))
            }
          } catch (error) {
            console.error('Error sending Offer Declined notification:', error)
          }
        }

        setProgress(100)
        setFailed(false)
        setBulkUploadResult(result?.data)
        setIsLoading(false)
      }
    } catch (error) {
      setProgress(100)
      setFailed(true)
      setBulkUploadError(error?.response?.data?.message)
      ErrorMessage(error?.response?.data?.message)
      setIsLoading(false)
    }
  }

  const [conflictDrawer, setConflictDrawer] = useState(false)
  const handleResolveConflict = async () => {
    setConflictDrawer(true)
    setConflictFilter({
      search: '',
      page: 0,
    })
    try {
      setIsLoading(true)
      let roundId = rolesMetrics?.rounds?.[parseInt(stageIndex) ?? 0]?.id

      const getConflictData = await resolveConflict(
        instituteCampusId,
        params?.roleId,
        0,
        '',
        roundId
      )
      setIsLoading(false)
      setConflictData(getConflictData)
    } catch (err) {
      ErrorMessage(err)
    }
  }

  const breadCrumbData = [
    {
      title: 'Job Role',
      name: 'Job Role',
      navigate: `/jobRoles`,
      active: false,
    },
    {
      title: checkType,
      name: checkType,
      navigate: `/jobRoles/jobPreview/${params?.roleId}`,
      active: false,
    },
    {
      title: 'Evaluation Process',
      name:
        jobRolePreviewData?.company?.companyName ??
        jobRolePreviewData?.corporate?.name,
      active: true,
    },
    // {
    //   title: 'Corporate',
    //   name: 'Corporate',
    //   navigate: `./Corporate`,
    //   active: false,
    // },
  ]

  const [corporateFilterStatus, setCorporateFilterStatus] = useState([])

  const menuOption = [
    ...(currentTab === 'ACTIVE' && stage !== 'all_candidates'
      ? [
          {
            label: 'Update Status',
            value: 'UPDATE STATUS',
            nameValue: 'Status - Update Status',
            role: 'Status',
            key: 'UPDATE_STATUS',
          },
        ]
      : [
          {
            label: 'Update Status',
            value: 'UPDATE STATUS',
            nameValue: 'Status - Update Status',
            role: 'Status',
            key: 'UPDATE_STATUS',
          },
          {
            label: 'Rejected',
            value: 'Rejected',
            nameValue: 'Status - Rejected',
            role: 'Status',
            key: 'REJECTED',
          },
          {
            label: 'Absent ',
            value: 'ABSENT',
            nameValue: 'Status - Absent',
            role: 'Status',
            key: 'ABSENT',
          },
          {
            label: 'Offer Issued',
            value: 'OFFER ISSUED',
            nameValue: 'Status - Offer Issued',
            role: 'Status',
            key: 'RELEASED',
          },
          {
            label: 'Offer Accepted',
            value: 'OFFER ACCEPTED',
            nameValue: 'Status - Offer Accepted',
            role: 'Status',
            key: 'ACCEPTED',
          },
          {
            label: 'Offer Declined',
            value: 'OFFER REJECTED',
            nameValue: 'Status - Offer Declined',
            role: 'Status',
            key: 'REJECTED',
          },
        ]),
  ]

  const handleDepartSearch = useCallback(
    Debounce(searchTerm => {
      //  handleDepart({ search: searchTerm })
    }, 1000),
    []
  )

  const handleDegreeSearch = useCallback(
    Debounce(searchTerm => {
      handleDegree({ search: searchTerm })
    }, 1000)
  )

  const closePopup = () => {
    setShowSuccessPopup(false)
  }
  const handleStatusChange = checkedValues => {
    const option =
      publishedBy === 'INSTITUTE' ? menuOption : corporateFilterStatus
    const checkdata = checkedValues.map(value => {
      return option.find(option => option.value === value)
    })

    setCheckStatus(checkdata)
  }

  const handleSkillsChange = checkedValues => {
    const checkdata = checkedValues.map(value => {
      return skillsFilter.find(option => option.value === value)
    })
    setCheckSkills(checkdata)
  }

  const handleYearChange = checkedValues => {
    const checkdata = checkedValues.map(value => {
      return yearFilter.find(option => option.value === value)
    })
    setCheckYear(checkdata)
  }

  const handleScoreChange = value => {
    setCheckScore(value)
  }

  const handleArrearsChange = value => {
    setCheckArrears(value)
  }

  const handleLocationChange = checkedValues => {
    const checkdata = checkedValues.map(value => {
      return locationFilter.find(option => option.value === value)
    })
    setCheckLocation(checkdata)
  }

  const handleGenderChange = checkedValues => {
    const checkdata = checkedValues.map(value => {
      return genderFilter.find(option => option.value === value)
    })
    setCheckGender(checkdata)
  }

  const [dummyOpen, setDummyOpen] = useState(false)
  useEffect(() => {
    if (!dummyOpen && !filterCheck) {
      const checkStatusData = []
      const selectedCourseData = []
      const degreeValueData = []
      const selectedDepartData = []
      const departValueData = []

      multiSelect.forEach((item, index) => {
        const uniqueKey = `${item.role}-${index}`
        if (item.role === 'Status') {
          checkStatusData.push({ ...item, key: uniqueKey })
        } else if (item.role === 'Degree') {
          selectedCourseData.push({ ...item, key: uniqueKey })
          degreeValueData.push(item.value)
        } else if (item.role === 'Department') {
          selectedDepartData.push({ ...item, key: uniqueKey })
          departValueData.push(item.value)
        }
      })

      // setCheckStatus(checkStatusData)

      setState({
        ...state,
        selectedCourse: selectedCourseData,
        degreeValue: degreeValueData,
        selectedDepartCourse: selectedDepartData,
        departValue: departValueData,
      })
    }
  }, [dummyOpen])

  useEffect(() => {
    if (filterCheck) {
      setMultiSelect([
        ...checkSkills,
        ...checkStatus,
        ...state.selectedCourse,
        ...state.selectedDepartCourse,
        ...state.selectedSplCourse,
        ...checkYear,
        ...scoreEntries,
        ...checkLocation,
        ...checkGender,
        ...ArrearsFilter,
      ])
      setFilterCheck(false)
    }
  }, [checkStatus, filterCheck, state])

  useEffect(() => {
    const formattedArrearsArray = []

    // Add past arrears object if it exists
    if (checkArrears?.past) {
      formattedArrearsArray.push({
        past: checkArrears.past,
        role: 'Arrears',
        nameValue: `History Of Arrears: ${checkArrears.past}`,
        value: `past-arrear-${checkArrears.past}`,
      })
    }

    // Add current arrears object if it exists
    if (checkArrears?.current) {
      formattedArrearsArray.push({
        current: checkArrears.current,
        role: 'Arrears',
        nameValue: `Current Arrear: ${checkArrears.current}`,
        value: `current-arrear-${checkArrears.current}`,
      })
    }

    setArrearsFilter(formattedArrearsArray)
  }, [checkArrears])

  const handleMultiFilter = selectedValue => {
    setFilterCheck(true)
    const multi = multiSelect.filter(
      item => !selectedValue.includes(item.nameValue)
    )

    const role = multi[0].role
    if (role === 'Status') {
      const getvalue = checkStatus.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setCheckStatus(getvalue)
    }
    if (role === 'Skills') {
      const getvalue = checkSkills.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setCheckSkills(getvalue)
    }
    if (role === 'Location') {
      const getvalue = checkLocation.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setCheckLocation(getvalue)
    }
    if (role === 'Year') {
      const getvalue = checkYear.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setCheckYear(getvalue)
    }
    if (role === 'Score') {
      const getvalue = scoreEntries.filter(
        item => !multi.some(getvalue => getvalue.nameValue === item.nameValue)
      )
      setScoreEntries(getvalue)
    }
    if (role === 'Gender') {
      const getvalue = checkGender.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      setCheckGender(getvalue)
    }
    if (role === 'Arrears') {
      const getvalue = ArrearsFilter.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )

      // Update the checkArrears object based on remaining arrears values
      const updatedCheckArrears = {}

      // Check if any past arrear remains in the filtered values
      const pastArrear = getvalue.find(item =>
        item.value.startsWith('past-arrear-')
      )
      if (pastArrear) {
        updatedCheckArrears.past = pastArrear.past
        if (checkArrears.pastType) {
          updatedCheckArrears.pastType = checkArrears.pastType
        }
      }

      // Check if any current arrear remains in the filtered values
      const currentArrear = getvalue.find(item =>
        item.value.startsWith('current-arrear-')
      )
      if (currentArrear) {
        updatedCheckArrears.current = currentArrear.current
        if (checkArrears.currentType) {
          updatedCheckArrears.currentType = checkArrears.currentType
        }
      }

      // Update both states
      setArrearsFilter(getvalue)
      setCheckArrears(updatedCheckArrears)
    }
    if (role === 'Degree') {
      const getvalue = state.selectedCourse.filter(
        item => !multi.some(getvalue => getvalue.value === item.value)
      )
      const getdata = state.selectedDepartCourse.filter(
        item => item.degreeId !== multi[0].value
      )
      const getvalue1 = state.selectedSplCourse.filter(
        item => item.degreeId !== multi[0].value
      )

      setState({
        ...state,
        degreeValue: getvalue,
        selectedCourse: getvalue,
        selectedDepartCourse: getdata,
        departValue: getdata?.map(item => item.value) || [],
        selectedSplCourse: getvalue1,
        splValue: getvalue1?.map(item => item.value) || [],
      })
    }
    if (role === 'Department') {
      const getvalue = state.selectedDepartCourse.filter(
        item => !multi.some(getvalue => getvalue.departId === item.departId)
      )
      const getdata = state.selectedSplCourse.filter(
        item => !multi.some(getvalue => getvalue.departId === item.departId)
      )

      setState({
        ...state,
        departValue: getvalue,
        selectedDepartCourse: getvalue,
        selectedSplCourse: getdata,
        splValue: getdata?.map(item => item.value) || [],
      })
    }
    if (role === 'Specialisation') {
      const getvalue = state.selectedSplCourse.filter(
        item =>
          !multi.some(
            getvalue => getvalue.specialisationId === item.specialisationId
          )
      )
      setState({
        ...state,
        splValue: getvalue,
        selectedSplCourse: getvalue,
      })
    }
  }

  const handleFilter = () => {
    setCurrentPage(0)
    setFilterCheck(true)
  }

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearchBy(searchBy)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchBy])

  const handleFilterSearch = e => {
    setCurrentPage(0)
    setSearchBy(e.target.value)
    setSelectedCandidateId([])
    setWholeSelect(false)
    setFilterSearchText(true)
  }

  const [state, setState] = useState({
    degreeValue: [],
    degreeList: [],
    selectedCourse: [],
    departList: [],
    departValue: [],
    selectedDepartCourse: [],
    splValue: [],
    splList: [],
    selectedSplCourse: [],
  })

  const handleDegree = async ({ search }) => {
    const data = await getCandidateDegree(
      instituteCampusId,
      params?.roleId,
      stage == 'offer' ? null : stageIndex,
      search,
      publishedBy
    )

    const domainData =
      data?.length !== 0 &&
      data?.result.map((item, index) => {
        return {
          title: item.name,
          value: item.id,
          domainId: item.id,
        }
      })

    const domainSelect = [
      {
        title: 'Select All',
        value: 'all',
        children: domainData,
      },
    ]
    data?.length !== 0 && data?.result?.length !== 0
      ? setState({ ...state, degreeList: domainSelect })
      : setState({ ...state, degreeList: [] })
  }

  const handleDepart = async ({ search }) => {
    try {
      const data = await getCandidateDepart(
        instituteCampusId,
        params?.roleId,
        stage == 'offer' ? null : stageIndex,
        state.selectedCourse,
        search,
        publishedBy
      )

      const getdata = data.map((item, index) => {
        let children = item.degreeStreamMap.map((stream, streamIndex) => {
          return {
            value: item?.id + ' ' + stream.stream.id,
            departId: stream.stream.id,
            title: stream.stream.name,
            nameValue: `Department - ${stream.stream.name}`,
            role: 'Department',
            degreeId: item.id,
          }
        })
        return {
          value: item.id,
          degreeId: item.id,
          title: item.name,
          children: children,
        }
      })
      const departSelect = [
        {
          title: 'Select All',
          value: 'all',
          children: getdata,
        },
      ]
      data.length !== 0
        ? setState({ ...state, departList: departSelect })
        : setState({ ...state, departList: [] })
    } catch (error) {
      ErrorMessage(error)
    }
  }
  const handleSpecialization = async ({ search }) => {
    try {
      const data = await getCandidateSpecialization(
        instituteCampusId,
        params?.roleId,
        stage == 'offer' ? null : stageIndex,
        state.selectedCourse,
        state.selectedDepartCourse,
        search,
        publishedBy
      )

      const splData = data.map(item => {
        let degreeChildren = item.degreeStreamMap.map(stream => {
          let specialisationChildren = stream.specialisationMasterStreamMap.map(
            specialisation => {
              return {
                value: `${stream.stream.id} ${specialisation.specialisationMaster.id}`,
                specialisationId: specialisation.specialisationMaster.id,
                title: specialisation.specialisationMaster.name,
                nameValue: `Specialisation - ${specialisation.specialisationMaster.name}`,
                role: 'Specialisation',
                degreeId: item.id,
                departId: stream.stream.id,
              }
            }
          )

          return {
            value: item.id + ' ' + stream.stream.id,
            departId: stream.stream.id,
            title: stream.stream.name,
            nameValue: `Department - ${stream.stream.name}`,
            role: 'Department',
            degreeId: item.id,
            children: specialisationChildren,
          }
        })

        return {
          value: item.id,
          degreeId: item.id,
          title: item.name,
          nameValue: `Degree - ${item.name}`,
          role: 'Degree',
          children: degreeChildren,
        }
      })

      const splSelect = [
        {
          title: 'Select All',
          value: 'all',
          children: splData,
        },
      ]
      data.length !== 0
        ? setState({ ...state, splList: splSelect })
        : setState({ ...state, splList: [] })
    } catch (error) {
      ErrorMessage(error)
    }
  }
  useEffect(() => {
    if (state.selectedDepartCourse.length !== 0) handleSpecialization({})
  }, [state.selectedDepartCourse])

  useEffect(() => {
    if (state.selectedCourse.length !== 0) handleDepart({})
  }, [state.selectedCourse])

  const handleDegreeChange = (value, label, extra) => {
    const triggerNode = extra.triggerNode.props
    const allCheckedNodes = extra.allCheckedNodes
    let selectedCourse = [],
      departCourse = state.selectedDepartCourse,
      departValue = state.departValue

    if (allCheckedNodes?.length === 0) {
      selectedCourse = []
      departCourse = []
      departValue = []
    } else if (triggerNode.value === 'all') {
      let select = triggerNode.children.map((item, index) => {
        return {
          domain: item.props.title,
          domainId: item.props.domainId,
          value: item.props.value,
          nameValue: `Degree - ${item.props.title}`,
          role: 'Degree',
        }
      })
      selectedCourse.push(...select)
    } else {
      const check = allCheckedNodes[0].children.length !== 0
      let allNode
      if (check) {
        allNode = allCheckedNodes[0].children.map((item, index) => {
          return {
            domain: item.node.props.title,
            domainId: item.node.props.domainId,
            value: item.node.props.value,
            nameValue: `Degree - ${item.node.props.title}`,
            role: 'Degree',
          }
        })
      } else {
        allNode = allCheckedNodes.map((item, index) => {
          return {
            domain: item.node.props.title,
            domainId: item.node.props.domainId,
            value: item.node.props.value,
            nameValue: `Degree - ${item.node.props.title}`,
            role: 'Degree',
          }
        })
      }
      if (state.selectedDepartCourse.length !== 0) {
        let check = state.selectedDepartCourse.filter(item =>
          value.includes(item.degreeId)
        )
        departCourse = check
        departValue = check.map(item => item.value)
      }

      selectedCourse.push(...allNode)
    }
    setState({
      ...state,
      degreeValue: value,
      selectedCourse: selectedCourse,
      departValue: departValue,
      selectedDepartCourse: departCourse,
    })
  }

  const handleDepartmentChange = (value, label, extra) => {
    const getFilter = state.departList[0].children.flatMap(item =>
      item.children.filter((child, index) => value.includes(child.value))
    )
    setState({
      ...state,
      departValue: value,
      selectedDepartCourse: getFilter,
    })
  }
  const handleSpecialisationChange = (value, label, extra) => {
    const getFilter = state.splList[0].children.flatMap(degree =>
      degree.children.flatMap(department =>
        department.children.filter(specialisation =>
          value.includes(specialisation.value)
        )
      )
    )
    setState({
      ...state,
      splValue: value,
      selectedSplCourse: getFilter,
    })
  }

  const [selectedKeys, setSelectedKeys] = useState([])
  const [targetKeys, setTargetKeys] = useState([])
  const [disabled, setDisabled] = useState(false)
  const [transfer, setTransfer] = useState(false)
  const [exportType, setExportType] = useState('')
  const [exportData, setExportData] = useState([])

  const [exportLoading, setExportLoading] = useState(false)

  const columns = [
    {
      dataIndex: 'title',
      title: 'Name',
    },
  ]

  const handleTransferClick = async isOpen => {
    try {
      if (isOpen) {
        let fieldDatas = await getExportFiledData(
          params.roleId,
          instituteCampusId,
          '',
          ''
        )
       fieldDatas = [
  {
    key: 'cv_link',
    title: 'CV Link',
  },
  ...fieldDatas.map((item, index) => ({
    key: index,
    title: item,
  }))
];
        setExportData(fieldDatas)
        // Reset selection when opening
        setSelectedExportMethod('')
        setSelectedExportType([])
      } else {
        setExportData([])
      }
      setSelectedKeys([])
      setExportType('')
      setTargetKeys([])
      setTransfer(isOpen)
    } catch (error) {}
  }

  const handleExportType = value => {
    if (exportType == value) {
      setExportType('')
    } else {
      setExportType(value)
    }
  }

  const handleExportClick = async () => {
    setExportLoading(true)
    try {

      // Construct filters object from current state
      const scoreData =
        scoreEntries?.length > 0
          ? scoreEntries?.reduce((acc, item) => {
              acc[item.qualification.value] = item.percentage
              return acc
            }, {})
          : undefined

      const scoreType =
        scoreEntries?.length > 0
          ? scoreEntries[0].comparisonType === 'greaterThan'
            ? 'gte'
            : scoreEntries[0].comparisonType === 'lessThan'
            ? 'lte'
            : scoreEntries[0].comparisonType
          : undefined

      const filters = {
        searchBy,
        status: status === 'ACTIVE' ? undefined : status,
        offerStatus: stage === 'offer' ? status : undefined,
        driveStatus: checkStatus?.map(item => item.value),
        skillIds: checkSkills?.map(item => item.id),
        locationIds: checkLocation?.map(item => item.id || item.value),
        gender: checkGender?.map(item => item.value),
        yearOfPassing: checkYear?.map(item => item.value),
        scores: scoreData,
        scoreFilterType: scoreType,
        arrears: checkArrears ? {
          past: checkArrears.past !== undefined && checkArrears.past !== null ? Number(checkArrears.past) : undefined,
          current: checkArrears.current !== undefined && checkArrears.current !== null ? Number(checkArrears.current) : undefined,
          pastType: checkArrears.pastType || undefined,
          currentType: checkArrears.currentType || undefined
        } : undefined,
        degreeIds: state.selectedCourse?.map(c => ({
          degreeId: c.domainId || c.value,
          streamId: state.selectedDepartCourse
            .filter(d => d.degreeId === c.value)
            .map(d => d.departId)
        })),
        collegeId: instituteCampusId,
        forInstitute: publishedBy === 'INSTITUTE',
        isTpo: publishedBy === 'INSTITUTE', 
        rating: undefined, 
        fromRating: undefined, 
        toRating: undefined ,
        stageIndex: stageIndex,
      };

      let payload = {
        downloadList: selectedKeys.map(item => item.title),
        stage: stage,
        filters: filters
      }

      console.log('=== EXPORT DEBUG ===')
      console.log('Selected Candidate IDs:', selectedCandidateId)
      console.log('Number of selected students:', selectedCandidateId?.length || 0)

      if (selectedCandidateId && selectedCandidateId.length > 0 && !selectAll) {
        payload.studentIds = selectedCandidateId
        console.log('Student IDs added to payload:', payload.studentIds)
      } else {
        // payload.studentIds = candidates?.result?.map(item => item.studentId) || []
        console.log('No students selected - will export using FILTERS')
      }

      console.log('Final Export Payload:', payload)
      console.log('===================')

      const effectiveExportType = selectedExportMethod === 'download' && !exportType && selectedExportType?.length > 0
        ? selectedExportType.find(t => ['xlsx', 'googlesheet', 'csv'].includes(t)) || exportType
        : exportType

      if (effectiveExportType === 'xlsx') {
        try {
          const blob = await atsExportCandidate(
            params.roleId,
            instituteCampusId,
            effectiveExportType,
            payload
          )
          console.log("Headers: ", JSON.stringify(blob, null, 2));
          if (blob?.headers?.['x-student-count']) {
            setStudentCount(blob?.headers?.['x-student-count'])
          }
          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Role.xlsx')
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
          if(selectedExportMethod === 'mail'){
            const file = new File([blob], 'Role.xlsx', { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            setExportFile(file); // Set the file
            if (blob?.headers?.['x-student-count']) {
              setStudentCount(blob?.headers?.['x-student-count'])
            }
            setIsEmailPopupVisible(true)
          }
          setExportLoading(false)
          handleTransferClick(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else if (effectiveExportType === 'googlesheet') {
        try {
          const response = await atsExportCandidate(
            params.roleId,
            instituteCampusId,
            effectiveExportType,
            payload
          )
          setGoogleSheetUrl(response?.data?.url)
          if (response?.data?.studentCount) {
            setStudentCount(response?.data?.studentCount)
          }
          setExportLoading(false)
          if (selectedExportMethod === 'mail') {
            setExportFile(null)
            setIsEmailPopupVisible(true)
          } else {
            window.open(response?.data?.url, '_blank')
          }
          handleTransferClick(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else if (effectiveExportType) {
        try {
          const blob = await atsExportCandidate(
            params.roleId,
            instituteCampusId,
            effectiveExportType,
            payload
          )
          if (blob?.headers?.['x-student-count']) {
            setStudentCount(blob?.headers?.['x-student-count'])
          }
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: 'text/csv' })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Export.csv')

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          if(selectedExportMethod === 'mail'){
            const file = new File([blob], 'Export.csv', { type: 'text/csv' });
            setExportFile(file); // Set the file
            if (blob?.headers?.['x-student-count']) {
              setStudentCount(blob?.headers?.['x-student-count'])
            }
            setIsEmailPopupVisible(true)
          }
          handleTransferClick(false)

          setExportLoading(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else {
        if (selectedExportMethod === 'mail' && selectedExportType.includes('cv_zip')) {
          try {
            const response = await atsExportCandidate(
              params.roleId,
              instituteCampusId,
              'count',
              payload
            )
            const numberOfStudents = response?.data?.studentCount || 0;
            setStudentCount(numberOfStudents)
          } catch (error) {
            console.error('Failed to fetch student count:', error)
          }
          setExportFile(null)
          setIsEmailPopupVisible(true)
          handleTransferClick(false)
        }
        setExportLoading(false)
      }
    } catch (error) {
      ErrorMessage(error)
    }
  }

  const handleClose = () => {
    setConflictDrawer(false)
    setConflictFilter({
      search: '',
      page: 0,
    })
  }
  const getCurrentExportCount = () => {
    if (stage === 'all_candidates') {
      return candidates?.count || 0
    }

    if (stage === 'offer') {
      if (publishedBy === 'INSTITUTE') {
        switch (currentTab) {
          case 'ACTIVE':
            return candidates?.activeCount || 0
          case 'RELEASED':
            return candidates?.offerIssuedCount || 0
          case 'ACCEPTED':
            return candidates?.offerAccepedCount || 0
          case 'REJECTED':
            return candidates?.offerDeclinedCount || 0
          default:
            return 0
        }
      }

      switch (currentTab) {
        case 'ACTIVE':
          return candidates?.intentToOfferCount || 0
        case 'RELEASED':
          return candidates?.offerCount || 0
        case 'ACCEPTED':
          return candidates?.offerAccpetCount || 0
        case 'REJECTED':
          return candidates?.offerRejectCount || 0
        default:
          return 0
      }
    }

    if (publishedBy === 'INSTITUTE') {
      switch (currentTab) {
        case 'ACTIVE':
          return candidates?.activeCount || 0
        case 'SHORTLISTED':
          return candidates?.shortlistedCount || 0
        case 'REJECTED':
          return candidates?.rejectedCount || 0
        case 'ABSENT':
          return candidates?.absentCount || 0
        default:
          return 0
      }
    }

    switch (currentTab) {
      case 'ACTIVE':
        return candidates?.totalCount || 0
      case 'SCHEDULED':
        return candidates?.scheduledCount || 0
      case 'RESCHEDULED':
        return candidates?.rescheduleCount || 0
      case 'QUALIFIED':
        return candidates?.qualifiedCount || 0
      case 'REJECTED':
        return candidates?.rejectedCount || 0
      case 'ABSENT':
        return candidates?.absentCount || 0
      default:
        return 0
    }
  }

  const currentExportCount = getCurrentExportCount()

  const isDisabled =
    !rolesMetrics ||
    (Array.isArray(rolesMetrics) && rolesMetrics.length === 0) ||
    currentExportCount === 0
  const statusDisabled =
    jobRolePreviewData?.jobRoleInstituteMap?.[0].roleStatus === 'ROLE_CLOSED' ||
    jobRolePreviewData?.jobRoleInstituteMap?.[0].roleStatus === 'COMPLETED'
  const handleClosePopup = () => {
    setBulkDownload(false)
    setPopup(false)
  }
  const handleApprove = async () => {
    setSelectAll(false)
    setPopup(false)
    let payload = {
      email: userData.email,
      instName: instituteDetails.campusName,
      state: instituteDetails.state,
      city: instituteDetails.city,
      user: userData.first_name + ' ' + userData.last_name,
      studentIds: selectAll === true ? studentListId : [selectedCandidateId],
    }

    setWholeSelect(false)
    setBulkDownload(false)
    
    // TODO: Revert back to original API after testing
    // const response = await resumeBulkDownload(payload)
        if (payload.studentIds[0].length > 5) {
      setShowSuccessPopup(true)
    }
    const response = await resumeBulkDownloadJobRoles({
      ...payload,
      roleId: params?.roleId
    })
 

    console.log('Resume download response:', response)
    console.log('Student count:', payload.studentIds[0].length)
  if (response?.data) {
        if (payload.studentIds[0].length === 1) {
    const studentData = candidates?.result.filter(
          p => p.studentId === payload.studentIds[0][0]
        )
        const studentName =
          studentData[0]?.student?.firstName +
          ' ' +
          studentData[0]?.student?.lastName
          await singlePdf(response,studentName,studentData[0]?.studentId);
        } else if (payload.studentIds[0].length <= 5) {
          await zipFile(response.data);
        }
      
    };
  }
  return (
    <>
      <SectionWrapper column>
        <div ref={object}></div>

        <TopHeader row spaceBetween alignCenter>
          <LeftSection centerVertically>
            <EmptyDivElement
              style={{ cursor: 'pointer' }}
              onClick={() =>
                navigate(
                  `/jobRoles/jobPreview/${params?.roleId}?selectedCategory=${jobRolePreviewData?.jobCategory}&q=ELIGIBLE`
                )
              }
            >
              <LeftArrow />
            </EmptyDivElement>
            <SectionName column disable={true}>
              <BreadCrumb breadCrumbData={breadCrumbData} />
              {}
              <TopHeading flexStart>
                {breadCrumbData[breadCrumbData.length - 1].name}
              </TopHeading>
            </SectionName>
          </LeftSection>
          <TopRightFlex>
            <div
              style={{
                cursor: statusDisabled ? 'not-allowed' : 'pointer',
                opacity: statusDisabled ? 0.5 : 1,
              }}
            >
              {publishedBy !== 'CORPORATE' && (
                <Button.Primary
                  height={'38px'}
                  text={'Schedule Evaluation process'}
                  onClick={() => {
                    if (!statusDisabled) {
                      setOpenDrawer(true)
                    }
                  }}
                />
              )}
            </div>
            <div
              style={{
                cursor: statusDisabled ? 'not-allowed' : 'pointer',
                opacity: statusDisabled ? 0.5 : 1,
              }}
            >
              {stage != 'all_candidates' && (
                <div
                  style={{
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    opacity: isDisabled ? 0.5 : 1,
                  }}
                  onClick={() => {
                    if (isDisabled || statusDisabled) return
                    setActionDrawer(true)
                    setSuccessFull(false)
                    setBulkUploadResult({})
                    setFinalUpload(0)
                    setConflictStatus('')
                  }}
                >
                  <BulkDownloadIcon />
                </div>
              )}
            </div>
            <div
              style={{
                cursor: isDisabled || statusDisabled ? 'not-allowed' : 'pointer',
                opacity: isDisabled || statusDisabled ? 0.5 : 1,
              }}
            >
              <div
                style={{
                  cursor: isDisabled || statusDisabled ? 'not-allowed' : 'pointer',
                }}
                onClick={() => {
                  if (
                    isDisabled ||
                    statusDisabled
                  ) {
                    return
                  }
                  console.log('Export Icon Clicked')
                  console.log('Current selected students:', selectedCandidateId?.length || 0)
                  console.log('Selected IDs:', selectedCandidateId)
                  handleTransferClick(true)
                }}
              >
                <AtsExportIcon
                  style={{
                    cursor: isDisabled || statusDisabled ? 'not-allowed' : 'pointer',
                    opacity: isDisabled || statusDisabled ? 0.5 : 1,
                  }}
                />
              </div>
            </div>
          </TopRightFlex>
        </TopHeader>
        <div style={{ marginLeft: '25px' }}>
          <DriveRoleMetrics
            rolesMetrics={rolesMetrics}
            selectedRound={selectedRound}
            setSelectedRound={setSelectedRound}
            setSearchParams={setSearchParams}
            setCurrentPage={setCurrentPage}
            setSelectedCandidateId={setSelectedCandidateId}
            setSelectedCandidate={setSelectedCandidate}
            setCurrentTab={setCurrentTab}
            setStatus={setStatus}
            setFilterStatus={setFilterStatus}
            setPanelData={setPanelData}
            setPanelValue={setPanelValue}
            onTabChange={onTabChange}
            checkType={checkType}
            setSearchBy={setSearchBy}
            setFilterSearchText={setFilterSearchText}
            setSelectAll={setSelectAll}
            setCheckStatus={setCheckStatus}
            setFilterCheck={setFilterCheck}
            publshedBy={publishedBy}
            setState={setState}
            setMultiSelect={setMultiSelect}
            setWholeSelect={setWholeSelect}
            setCheckGender={setCheckGender}
            setCheckSkills={setCheckSkills}
            setCheckYear={setCheckYear}
            setScoreEntries={setScoreEntries}
            setCheckArrears={setCheckArrears}
            setCheckLocation={setCheckLocation}
          />
        </div>

        <div style={{ marginTop: '10px' }}>
          {stage == 'all_candidates' ? (
            <IndividualDriveTable
              load={load}
              setPanelData={setPanelData}
              panelData={panelData}
              panelValue={panelValue}
              setPanelValue={setPanelValue}
              selectedCandidate={selectedCandidate}
              stages={stage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              rolesMetrics={rolesMetrics}
              setSearchParams={setSearchParams}
              setSelectedCandidateId={setSelectedCandidateId}
              status={status}
              stage={stage}
              setStatus={setStatus}
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              selectedCandidateId={selectedCandidateId}
              instituteCampusId={instituteCampusId}
              currentTab={currentTab}
              candidates={candidates}
              onPageChange={onPageChange}
              setSelectedCandidate={setSelectedCandidate}
              updateCandidateRoleStatus={updateCandidateRoleStatus}
              roleId={params?.roleId}
              setUpdateStatus={setUpdateStatus}
              handleResolveConflict={handleResolveConflict}
              conflictData={conflictData}
              stageIndex={stageIndex}
              menuOption={
                publishedBy === 'INSTITUTE' ? menuOption : corporateFilterStatus
              }
              handleStatusChange={handleStatusChange}
              checkStatus={checkStatus}
              multiSelect={multiSelect}
              handleMultiFilter={handleMultiFilter}
              handleFilter={handleFilter}
              handleFilterSearch={handleFilterSearch}
              searchBy={searchBy}
              handleDegreeChange={handleDegreeChange}
              state={state}
              handleDepartmentChange={handleDepartmentChange}
              handleSpecialisationChange={handleSpecialisationChange}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              publishedBy={publishedBy}
              setDummyOpen={setDummyOpen}
              dummyOpen={dummyOpen}
              getPreview={getPreview}
              getJobRolePreview={getJobRolePreview}
              getStudentPlacedList={getStudentPlacedList}
              getPlacementHistoryList={getPlacementHistoryList}
              setWholeSelect={setWholeSelect}
              wholeSelect={wholeSelect}
              setSortBy={setSortBy}
              fetchCandidateList={fetchCandidateList}
              handleDegreeSearch={handleDegreeSearch}
              handleDepartSearch={handleDepartSearch}
              jobRolePreviewData={jobRolePreviewData}
              handleGenderChange={handleGenderChange}
              handleSkillsChange={handleSkillsChange}
              handleYearChange={handleYearChange}
              handleScoreChange={handleScoreChange}
              handleArrearsChange={handleArrearsChange}
              handleLocationChange={handleLocationChange}
              checkGender={checkGender}
              checkSkills={checkSkills}
              checkYear={checkYear}
              checkScore={checkScore}
              checkArrears={checkArrears}
              checkLocation={checkLocation}
              skillsFilter={skillsFilter}
              locationFilter={locationFilter}
              setBulkDownload={setBulkDownload}
              setPopup={setPopup}
              yearFilter={yearFilter}
              genderFilter={genderFilter}
              scoreEntries={scoreEntries}
              setScoreEntries={setScoreEntries}
            />
          ) : (
            <StyledTab
              onChange={onTabChange}
              width={'100% !important'}
              activeKey={currentTab}
              defaultActiveKey={currentTab}
              height={stage === 'all_candidates'}
            >
              {(stage === 'offer' ? OfferTabList : tabList)?.map(data => {
                return (
                  <TabPane
                    tab={
                      <Fragment>
                        {data?.tabName}
                        <CandidatesSpan>
                          {getZeroBeforeInt(data?.count)}
                        </CandidatesSpan>
                      </Fragment>
                    }
                    key={data?.key}
                  >
                    <IndividualDriveTable
                      load={load}
                      roleId={params?.roleId}
                      setUpdateStatus={setUpdateStatus}
                      instituteCampusId={instituteCampusId}
                      updateCandidateRoleStatus={updateCandidateRoleStatus}
                      setSelectedCandidate={setSelectedCandidate}
                      setPanelData={setPanelData}
                      panelData={panelData}
                      panelValue={panelValue}
                      setPanelValue={setPanelValue}
                      selectedCandidate={selectedCandidate}
                      stages={stage}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      rolesMetrics={rolesMetrics}
                      setSearchParams={setSearchParams}
                      setSelectedCandidateId={setSelectedCandidateId}
                      status={status}
                      stage={stage}
                      setStatus={setStatus}
                      filterStatus={filterStatus}
                      setFilterStatus={setFilterStatus}
                      selectedCandidateId={selectedCandidateId}
                      currentTab={currentTab}
                      candidates={candidates}
                      onPageChange={onPageChange}
                      handleResolveConflict={handleResolveConflict}
                      conflictData={conflictData}
                      stageIndex={stageIndex}
                      menuOption={
                        publishedBy === 'INSTITUTE'
                          ? menuOption
                          : corporateFilterStatus
                      }
                      handleStatusChange={handleStatusChange}
                      checkStatus={checkStatus}
                      multiSelect={multiSelect}
                      handleMultiFilter={handleMultiFilter}
                      handleFilter={handleFilter}
                      handleFilterSearch={handleFilterSearch}
                      searchBy={searchBy}
                      state={state}
                      handleDegreeChange={handleDegreeChange}
                      handleDepartmentChange={handleDepartmentChange}
                      handleSpecialisationChange={handleSpecialisationChange}
                      selectAll={selectAll}
                      setSelectAll={setSelectAll}
                      publishedBy={publishedBy}
                      setDummyOpen={setDummyOpen}
                      dummyOpen={dummyOpen}
                      getPreview={getPreview}
                      getJobRolePreview={getJobRolePreview}
                      getStudentPlacedList={getStudentPlacedList}
                      getPlacementHistoryList={getPlacementHistoryList}
                      setWholeSelect={setWholeSelect}
                      wholeSelect={wholeSelect}
                      setSortBy={setSortBy}
                      fetchCandidateList={fetchCandidateList}
                      handleDegreeSearch={handleDegreeSearch}
                      handleDepartSearch={handleDepartSearch}
                      jobRolePreviewData={jobRolePreviewData}
                      handleGenderChange={handleGenderChange}
                      handleSkillsChange={handleSkillsChange}
                      handleYearChange={handleYearChange}
                      handleScoreChange={handleScoreChange}
                      handleArrearsChange={handleArrearsChange}
                      handleLocationChange={handleLocationChange}
                      checkGender={checkGender}
                      checkSkills={checkSkills}
                      checkYear={checkYear}
                      checkScore={checkScore}
                      checkArrears={checkArrears}
                      checkLocation={checkLocation}
                      skillsFilter={skillsFilter}
                      locationFilter={locationFilter}
                      setBulkDownload={setBulkDownload}
                      setPopup={setPopup}
                      yearFilter={yearFilter}
                      genderFilter={genderFilter}
                      scoreEntries={scoreEntries}
                      setScoreEntries={setScoreEntries}
                    />
                  </TabPane>
                )
              })}
            </StyledTab>
          )}
        </div>
      </SectionWrapper>
      <Drawer
        width="40%"
        title={'Schedule'}
        placement="right"
        closable={true}
        visible={openDrawer}
        content={content()}
        footer={footer()}
        onClose={() => {
          setOpenDrawer(false)
          removeParams()
          setIsEditingForm(false)
        }}
      />
      <Drawer
        width="40%"
        title={'Bulk Upload'}
        placement="right"
        closable={true}
        visible={actionDrawer}
        content={uploaderContent()}
        footer={
          successFull || file === undefined || file === null
            ? false
            : uploadFooter()
        }
        onClose={() => {
          setFile('')
          setActionDrawer(false)
          fetchCandidateList(params?.roleId)
          getConflict()
        }}
      />
      <Drawer
        width="70%"
        title={'Conflicts'}
        placement="right"
        closable={true}
        visible={conflictDrawer}
        content={ConflictContent()}
        footer={false}
        zIndex={1005}
        onClose={() => handleClose()}
      />
      <ExportTransfer
        open={transfer}
        handleClose={handleTransferClick}
        data={exportData}
        columns={columns}
        disabled={disabled}
        targetKeys={targetKeys}
        setTargetKeys={setTargetKeys}
        setSelectedKeys={setSelectedKeys}
        exportType={exportType}
        handleExportType={handleExportType}
        handleExportClick={handleExportClick}
        exportLoading={exportLoading}
        setExportLoading={setExportLoading}
        setDisabled={setDisabled}
        hasEmailAndDownload={true}
        setIsEmailPopupVisible={setIsEmailPopupVisible}
        setSelectedExportMethod={setSelectedExportMethod}
        setSelectedExportType={setSelectedExportType}
        selectedExportMethod={selectedExportMethod}
        selectedExportType={selectedExportType}
      />
      <CloseRoleDrawer
        description="Are you sure you want to download all selected resumes?"
        Icon={PopUpPageIcon}
        showDrawer={popup}
        setShowDrawer={setPopup}
        onCloseClick={handleClosePopup}
        onApprove={handleApprove}
        closeText="No"
        YesText="Yes"
        closeButtonHeight="38px"
        closeButtonWidth="80px"
        yesButtonHeight="38px"
        yesButtonWidth="105px"
      />
      <SucessfullPopup
        description={
          <div>
            Your request is being processed. Please check your email inbox
            shortly for the download link.
          </div>
        }
        Icon={SuccessIcon}
        showDrawer={showSuccessPopup}
        setShowDrawer={setShowSuccessPopup}
        onCloseClick={closePopup}
      />

      {isEmailPopupVisible && (
        <EmailPopup
          visible={isEmailPopupVisible}
          onCancel={() => {
            setIsEmailPopupVisible(false);
            setExportFile(null); // Clear file on cancel
            // Reset selection on cancel
            setSelectedExportMethod('')
            setSelectedExportType([])
          }}
          onSuccess={() => {
            setIsEmailPopupVisible(false); // Close EmailPopup
            setExportFile(null);
            // Reset selection on success
            setSelectedExportMethod('')
            setSelectedExportType([])
            setShowEmailSuccessDialog(true); // Open SuccessDialog
          }}
          exportFile={exportFile} // Pass the file prop
          selectedExportType={selectedExportType}
          companyName={
            jobRolePreviewData?.company?.companyName ??
            jobRolePreviewData?.corporate?.name ??
            'the company'
          }
          roleName={
            jobRolePreviewData?.tittle ??
            rolesMetrics?.tittle ??
            'the role'
          }
          signatureName={
            userData?.first_name + ' ' + userData?.last_name
          }
          signatureRole={getUserRoleName()}
          signatureInstitute={institute?.campusName || 'Institute'}
          googleSheetUrl={googleSheetUrl}
          roleId={params?.roleId}
          instituteCampusId={instituteCampusId}
          selectedCandidateId={selectedCandidateId}
          stageName={stage}
          totalStudentsCount={
            studentCount
          }
          selectAll={selectAll}
          filters={{
            searchBy,
            stageIndex: stageIndex,
            status: status === 'ACTIVE' ? undefined : status,
            offerStatus: stage === 'offer' ? status : undefined,
            driveStatus: checkStatus?.map(item => item.value),
            skillIds: checkSkills?.map(item => item.id),
            locationIds: checkLocation?.map(item => item.id || item.value),
            gender: checkGender?.map(item => item.value),
            yearOfPassing: checkYear?.map(item => item.value),
            scores: scoreEntries?.length > 0
              ? scoreEntries?.reduce((acc, item) => {
                  acc[item.qualification.value] = item.percentage
                  return acc
                }, {})
              : undefined,
            scoreFilterType: scoreEntries?.length > 0
              ? scoreEntries[0].comparisonType === 'greaterThan'
                ? 'gte'
                : scoreEntries[0].comparisonType === 'lessThan'
                ? 'lte'
                : scoreEntries[0].comparisonType
              : undefined,
            arrears: checkArrears ? {
              past: checkArrears.past !== undefined && checkArrears.past !== null ? Number(checkArrears.past) : undefined,
              current: checkArrears.current !== undefined && checkArrears.current !== null ? Number(checkArrears.current) : undefined,
              pastType: checkArrears.pastType || undefined,
              currentType: checkArrears.currentType || undefined
            } : undefined,
            degreeIds: state.selectedCourse?.map(c => ({
              degreeId: c.domainId || c.value,
              streamId: state.selectedDepartCourse
                .filter(d => d.degreeId === c.value)
                .map(d => d.departId)
            })),
            collegeId: instituteCampusId,
            forInstitute: publishedBy === 'INSTITUTE',
            isTpo: publishedBy === 'INSTITUTE',
          }}
        />
      )}

      {/* Render SuccessDialog here, outside of EmailPopup condition */}
      <SuccessDialog 
        isOpen={showEmailSuccessDialog} 
        onClose={() => setShowEmailSuccessDialog(false)} 
      />
    </>
  )
}
export default PageHeader
